import React from "react";
const IcCurrency = ({ name }: { name: string }) => {
  return (
    <div>
      {(() => {
        switch (name) {
          default:
          case "usd":
            return (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip_us)">
                  <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M11.4779 12H23.9996C23.9996 10.9169 23.8552 9.86768 23.5862 8.86957H11.4779V12Z"
                    fill="#D80027"
                  />
                  <path
                    d="M11.4779 5.73855H22.2383C21.5038 4.53986 20.5645 3.48034 19.4694 2.60809H11.4779V5.73855Z"
                    fill="#D80027"
                  />
                  <path
                    d="M11.9997 24C14.8239 24 17.4197 23.0239 19.4695 21.3914H4.52991C6.57975 23.0239 9.17555 24 11.9997 24Z"
                    fill="#D80027"
                  />
                  <path
                    d="M1.76104 18.2599H22.2385C22.8282 17.2976 23.2856 16.2457 23.5864 15.1295H0.413147C0.713944 16.2457 1.1713 17.2976 1.76104 18.2599Z"
                    fill="#D80027"
                  />
                  <path
                    d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
                    fill="#0052B4"
                  />
                </g>
                <defs>
                  <clipPath id="clip_us">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            );

          case "eur":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_736)">
                  <path
                    fill="#FFDA44"
                    d="M.746 16.175C2.442 20.745 6.84 24 12 24s9.558-3.257 11.253-7.826L12 15.132z"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 0C6.84 0 2.442 3.258.746 7.828L12 8.87l11.253-1.043C21.559 3.257 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M.746 7.826A12 12 0 0 0 0 12c0 1.467.264 2.874.746 4.174h22.508c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_736">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          case "afn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_576)">
                  <path
                    fill="#D80027"
                    d="M17.217 1.19A11.95 11.95 0 0 0 12 0c-1.87 0-3.64.428-5.218 1.19L5.74 12l1.043 10.81A11.95 11.95 0 0 0 12 24c1.87 0 3.64-.428 5.217-1.19L18.261 12z"
                  ></path>
                  <path
                    fill="#000"
                    d="M6.783 1.191A12 12 0 0 0 0 12.001a12 12 0 0 0 6.783 10.808z"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M17.218 1.191V22.81A12 12 0 0 0 24 12a12 12 0 0 0-6.782-10.809"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 7.827a4.174 4.174 0 1 0 0 8.347 4.174 4.174 0 0 0 0-8.347m0 6.782a2.609 2.609 0 1 1 0-5.217 2.609 2.609 0 0 1 0 5.217"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 10.436c-.576 0-1.043.467-1.043 1.044v1.565h2.086V11.48c0-.577-.467-1.044-1.043-1.044"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_576">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bob":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_583)">
                  <path
                    fill="#FFDA44"
                    d="M24 12c0-1.467-.264-2.873-.746-4.173L12 7.305.746 7.827A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.173L12 16.696l11.254-.521c.482-1.3.746-2.706.746-4.174"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.826H.746C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M.746 7.826h22.507C21.558 3.256 17.16 0 12 0 6.84 0 2.442 3.257.746 7.826"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_583">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "hrk":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 18 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 15C0 7 4.724 0 9 0C13.276 0 18 7 18 15C18 19.971 13.971 24 9 24C4.029 24 0 19.971 0 15ZM10 6C9.448 6 9 6.448 9 7C9 7.552 9.448 8 10 8C10.552 8 11 7.552 11 7C11 6.448 10.552 6 10 6ZM11.5 14C10.672 14 10 13.328 10 12.5C10 11.672 10.672 11 11.5 11C12.328 11 13 11.672 13 12.5C13 13.328 12.328 14 11.5 14ZM4 16.5C4 17.88 5.12 19 6.5 19C7.88 19 9 17.88 9 16.5C9 15.12 7.88 14 6.5 14C5.12 14 4 15.12 4 16.5Z"
                  fill={"#FFFFFF"}
                />
              </svg>
            );

          case "gmd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_612)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M12 0C7.04 0 2.782 3.012.954 7.306h22.093C21.219 3.011 16.96.001 12 .001"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M12 24c4.961 0 9.219-3.01 11.047-7.304H.954C2.782 20.99 7.04 24.001 12 24.001"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M23.586 8.87H.413A12 12 0 0 0 0 12c0 1.083.144 2.132.413 3.13h23.174c.268-.998.413-2.047.413-3.13s-.145-2.132-.414-3.13"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_612">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ils":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_617)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M16.518 9.392h-3.012l-1.507-2.609-1.506 2.61H7.481L8.987 12l-1.506 2.608h3.012L12 17.22l1.507-2.61h3.012l-1.506-2.608zm-2.668 2.609-.925 1.602h-1.85l-.926-1.602.925-1.603h1.85zM12 8.796l.344.596h-.689zm-2.776 1.602h.689l-.345.597zm0 3.205.344-.596.345.596zm2.775 1.603-.344-.597h.689zm2.776-1.603h-.689l.345-.596zm-.689-3.205h.69l-.345.597zM19.47 2.609H4.53a12 12 0 0 0-2.769 3.13H22.24a12 12 0 0 0-2.77-3.13M4.53 21.391h14.94a12 12 0 0 0 2.768-3.13H1.761a12 12 0 0 0 2.769 3.13"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_617">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "aud":
            return (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_0_627)">
                  <path
                    d="M17.2169 1.19044C15.6393 0.4276 13.8695 -0.000274658 11.9996 -0.000274658C10.1297 -0.000274658 8.35982 0.4276 6.78219 1.19044L5.73871 11.9997L6.78219 22.809C8.35982 23.5718 10.1297 23.9997 11.9996 23.9997C13.8695 23.9997 15.6393 23.5718 17.2169 22.809L18.2604 11.9997L17.2169 1.19044Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M6.78256 1.19124C2.76861 3.13214 -6.10352e-05 7.24257 -6.10352e-05 12.0001C-6.10352e-05 16.7576 2.76861 20.8681 6.78256 22.809V1.19124Z"
                    fill="#6DA544"
                  />
                  <path
                    d="M17.2172 1.19122V22.8089C21.2311 20.868 23.9998 16.7576 23.9998 12.0001C23.9998 7.2426 21.2311 3.13213 17.2172 1.19122Z"
                    fill="#6DA544"
                  />
                  <path
                    d="M15.1305 15.6516L12 5.73859L8.86957 15.6516H11.2174V18.2603H12.7826V15.6516H15.1305Z"
                    fill="#6DA544"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_627">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            );

          case "svc":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_623)">
                  <path
                    fill="#FFDA44"
                    d="M16.174.746A12 12 0 0 0 12-.001c-1.467 0-2.874.265-4.174.747L6.783 11.999l1.043 11.254c1.3.482 2.707.747 4.174.747s2.874-.265 4.174-.747L17.218 12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12c0-5.16-3.257-9.558-7.826-11.253v22.507C20.744 21.558 24 17.16 24 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M0 12c0 5.159 3.257 9.558 7.826 11.253V.746C3.256 2.44 0 6.84 0 11.999"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_623">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "srd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_641)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M23.253 7.827H.746A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174h22.507c.483-1.3.747-2.706.747-4.174s-.264-2.874-.747-4.174"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12.035 24.001c4.11 0 7.737-2.067 9.9-5.217h-19.8a11.99 11.99 0 0 0 9.9 5.217M12.034 0c4.11 0 7.737 2.067 9.9 5.218h-19.8A11.99 11.99 0 0 1 12.035 0"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 7.827 1.036 3.188h3.352l-2.712 1.971 1.036 3.189-2.713-1.971-2.712 1.97 1.036-3.188-2.712-1.97h3.353z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_641">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "cup":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_662)">
                  <path fill="#FF9811" d="M0 2.087v19.826V2.087"></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12S0 5.373 0 12c0 6.628 5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 0a11.98 11.98 0 0 0-9.6 4.8h19.2A11.98 11.98 0 0 0 12 0M12 24c3.925 0 7.41-1.885 9.6-4.8H2.4a11.98 11.98 0 0 0 9.6 4.8M0 12c0 .822.083 1.625.24 2.4h23.52a12.1 12.1 0 0 0 0-4.8H.24C.083 10.376 0 11.178 0 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.515 3.515c-4.686 4.686-4.686 12.284 0 16.97L12 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m4.857 8.87.776 2.39h2.515L6.114 12.74l.777 2.391-2.034-1.478-2.035 1.478.777-2.391-2.034-1.478H4.08z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_662">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "gel":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_671)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M7.304 5.74V4.175H5.74V5.74H4.174v1.565h1.565V8.87h1.565V7.305H8.87V5.74zM18.26 5.74V4.175h-1.564V5.74H15.13v1.565h1.566V8.87h1.565V7.305h1.565V5.74zM7.304 16.697v-1.565H5.74v1.565H4.174v1.565h1.565v1.565h1.565v-1.565H8.87v-1.565zM18.26 16.697v-1.565h-1.564v1.565H15.13v1.565h1.566v1.565h1.565v-1.565h1.565v-1.565z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_671">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mlt":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_683)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12"
                  ></path>
                  <path
                    fill="#ACABB1"
                    d="M8.348 4.696V3.131H6.782v1.565H5.217v1.565h1.565v1.566h1.566V6.26h1.565V4.696z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_683">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "kpw":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_687)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 0a11.97 11.97 0 0 0-9.097 4.174h18.193A11.97 11.97 0 0 0 12 0M21.096 19.827H2.903A11.97 11.97 0 0 0 12 24c3.637 0 6.895-1.619 9.096-4.174"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M22.239 5.739H1.76a11.94 11.94 0 0 0-1.76 6.26c0 2.295.643 4.439 1.76 6.261H22.24A11.94 11.94 0 0 0 24 12c0-2.295-.644-4.439-1.761-6.261"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M7.383 16.618a4.617 4.617 0 1 0 0-9.235 4.617 4.617 0 0 0 0 9.235"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m7.382 7.383 1.036 3.189h3.358l-2.717 1.97 1.044 3.199-2.72-1.98-2.717 1.976 1.04-3.194-2.715-1.971h3.355z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_687">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "wst":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_695)">
                  <path
                    fill="#D80027"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 12V0C5.373 0 0 5.373 0 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m9.612 7.826.194.598h.628l-.508.37.194.597-.508-.37-.51.37.195-.597-.508-.37h.628zM6.454 3.131l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048zM9.585 4.175l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048zM7.11 8.349l.324.997h1.048l-.848.615.324.997-.847-.616-.848.616.324-.997-.848-.615h1.048zM4.368 5.74l.323.996H5.74l-.848.616.324.997-.847-.616-.848.616.324-.997-.848-.616h1.048z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_695">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "szl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_695)">
                  <path
                    fill="#D80027"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 12V0C5.373 0 0 5.373 0 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m9.612 7.826.194.598h.628l-.508.37.194.597-.508-.37-.51.37.195-.597-.508-.37h.628zM6.454 3.131l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048zM9.585 4.175l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048zM7.11 8.349l.324.997h1.048l-.848.615.324.997-.847-.616-.848.616.324-.997-.848-.615h1.048zM4.368 5.74l.323.996H5.74l-.848.616.324.997-.847-.616-.848.616.324-.997-.848-.616h1.048z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_695">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "all":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_719)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M18.783 8.907h-4.347A1.565 1.565 0 1 0 12 6.961a1.564 1.564 0 0 0-2.87.866c0 .42.165.8.434 1.08H5.217c0 1.153 1.004 2.087 2.157 2.087h-.07c0 1.153.935 2.087 2.087 2.087 0 .374.099.724.27 1.027l-1.73 1.73 1.327 1.329 1.884-1.884q.11.041.23.063l-1.14 2.57L12 19.827l1.767-1.91-1.139-2.57q.12-.022.23-.063l1.883 1.884 1.329-1.328-1.732-1.732c.172-.302.27-.652.27-1.026a2.087 2.087 0 0 0 2.087-2.087h-.069c1.152 0 2.156-.934 2.156-2.087"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_719">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bam":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_722)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 0A11.99 11.99 0 0 0 1.877 5.552L18.15 22.305A11.99 11.99 0 0 0 24 11.999c0-6.627-5.373-12-12-12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M24 12c0-3.114-1.186-5.95-3.13-8.083v16.165A11.96 11.96 0 0 0 24 11.999M14.99 22.587h1.257l.388-1.197.39 1.196h.63q.58-.312 1.12-.682L2.095 5.224q-.412.602-.75 1.254l.147.455H2.75l-1.016.74.39 1.194-1.018-.738-.607.442A12 12 0 0 0 0 11.999c0 6.627 5.373 12 12 12 1.402 0 2.746-.24 3.996-.682zM2.678 11.477l.388-1.195-1.018-.739h1.257l.388-1.196.39 1.195h1.256l-1.016.739.389 1.195-1.018-.738zm2.589 2.61.387-1.197-1.017-.738h1.257l.388-1.196.389 1.195h1.257l-1.017.739.39 1.195-1.018-.738zm2.588 2.608.388-1.196-1.017-.738 1.257-.001.387-1.196.39 1.196 1.256-.001-1.016.74.389 1.194-1.017-.738zm3.605 1.869-1.016.74.388-1.196-1.018-.739h1.257l.388-1.196.389 1.195h1.257l-1.016.739.389 1.195zm1.572 3.348.388-1.195-1.017-.739h1.257l.387-1.196.39 1.195h1.257l-1.017.739.39 1.195-1.018-.738z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_722">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          case "ang":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_728)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 24c3.937 0 7.432-1.896 9.62-4.825H2.38A11.98 11.98 0 0 0 12 24M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 1.419.247 2.78.7 4.044h22.6c.453-1.264.7-2.625.7-4.044"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m8.214 7.696.647 1.993h2.096L9.26 10.92l.648 1.992-1.695-1.231-1.696 1.231.648-1.992-1.695-1.232h2.095zM4.615 5.61l.388 1.195h1.258l-1.017.74.388 1.195L4.615 8l-1.017.74.388-1.196-1.017-.739h1.258z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_728">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "jmd":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24.0057 12.0407C24.0131 12.0351 24.0205 12.0295 24.0277 12.0237C24.0277 12.0201 24.0277 12.0166 24.0277 12.013C24.0277 12.0099 24.0278 12.0067 24.0278 12.0036C24.0252 12.0018 24.0224 12.0001 24.0197 11.9984C24.0139 11.9949 24.0082 11.9914 24.0035 11.9867C23.5693 11.5524 23.1352 11.118 22.7012 10.6836C22.2656 10.2477 21.83 9.81182 21.3943 9.376C21.3773 9.35903 21.3588 9.34363 21.3465 9.33345C21.3424 9.33004 21.339 9.32722 21.3366 9.32512L18.6484 12.0132L21.3355 14.7004C21.3413 14.6948 21.3477 14.6887 21.3545 14.6822C21.3724 14.665 21.3932 14.6451 21.4135 14.6248C21.6561 14.3822 21.8987 14.1396 22.1413 13.8971C22.7475 13.291 23.3536 12.6849 23.96 12.079C23.974 12.065 23.9899 12.0529 24.0057 12.0407ZM4.63504 7.36544L7.3328 10.0629L12.0006 5.39536L16.6734 10.0682C16.806 9.96568 19.3334 7.42664 19.3635 7.37232L11.9906 0C11.8835 0.0816 4.66544 7.31112 4.63504 7.36544ZM11.9962 18.6178L7.32312 13.9449C6.41712 14.8482 5.51832 15.7443 4.63112 16.6291L12.0019 24L19.3716 16.6307L16.6798 13.9424L16.1532 14.4689L15.6353 14.9868L15.1174 15.5047L14.5994 16.0226L14.0744 16.5476L13.5565 17.0655L13.0386 17.5834C12.9868 17.6352 12.935 17.6871 12.8833 17.739C12.7626 17.86 12.6419 17.981 12.5204 18.1011C12.4656 18.1553 12.4115 18.2101 12.3571 18.2651C12.2403 18.3834 12.1226 18.5025 11.9962 18.6178ZM9.28032 12.007L12.0015 14.7281L14.7202 12.0095L11.999 9.2884L9.28032 12.007ZM2.67512 9.32673L0 12.0018L2.67832 14.6801L5.35312 12.0047L2.67512 9.32673Z"
                  fill="#F4B92E"
                />
              </svg>
            );

          case "sek":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M38 19C38 8.50622 29.4938 0 19 0C8.50622 0 0 8.50622 0 19C0 29.4938 8.50622 38 19 38C29.4938 38 38 29.4938 38 19ZM27.7433 12.8803C27.5409 14.986 25.9036 25.6723 25.5542 26.7446C25.256 27.6607 24.9404 28.4496 24.3415 28.4496C23.7426 28.4496 23.0883 28.2406 22.4431 27.7797C21.798 27.3187 17.5147 24.4456 16.9191 24.0705C16.3978 23.7417 15.846 22.9206 16.6233 22.1284C17.0214 21.7226 19.049 19.7474 20.6256 18.2114C21.5848 17.277 22.3771 16.5051 22.534 16.3483C22.9487 15.9327 22.5439 15.4016 22.0367 15.8163C21.5287 16.231 14.4549 20.9644 13.8419 21.3453C13.2637 21.7046 12.2319 21.9219 11.3257 21.6716C10.3847 21.4122 8.79122 20.9289 8.15843 20.7034C7.55044 20.4861 7.32987 20.2771 7.32987 19.9054C7.32987 19.3767 8.075 19.0116 8.86309 18.677C9.69413 18.3234 24.078 12.2162 25.2031 11.8106C26.0234 11.5148 26.7305 11.4 27.208 11.6297C27.6029 11.8188 27.8044 12.2426 27.7433 12.8803Z"
                  fill="white"
                />
              </svg>
            );

          case "dzd":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 38 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19 0C14.9695 0 13.3 2.58527 13.3 5.7C13.3 6.7488 13.8022 7.80286 13.8022 7.80286C13.6008 7.9194 13.2659 8.28976 13.3495 8.94336C13.5053 10.1619 14.0343 10.4692 14.3712 10.4945C14.4992 11.632 15.7231 13.0885 16.15 13.3V14.9996C15.7933 16.0698 14.4989 16.6771 13.0213 17.3703C10.564 18.5232 7.6 19.9138 7.6 24.0667H30.4C30.4 19.9138 27.436 18.5232 24.9787 17.3703C23.5011 16.6771 22.2067 16.0698 21.85 14.9996V13.3C22.2781 13.0885 23.5008 11.632 23.6288 10.4945C23.9657 10.4692 24.4947 10.1619 24.6505 8.94336C24.7341 8.28849 24.3992 7.9194 24.1978 7.80286C24.1978 7.80286 24.7 6.8514 24.7 5.7C24.7 3.3934 23.7943 1.425 21.85 1.425C21.85 1.425 21.1749 0 19 0ZM28.5 2.53086C27.8515 2.53086 27.2996 2.64816 26.793 2.81536C27.0704 3.67543 27.2333 4.63473 27.2333 5.7C27.2333 6.37387 27.1276 6.99166 26.9934 7.50846C27.177 8.05186 27.2401 8.64943 27.1616 9.2625C26.983 10.6571 26.4415 11.605 25.7613 12.2016C25.5637 12.6804 25.2932 13.134 25.0018 13.5672C25.3616 14.3057 25.8881 14.9631 26.125 15.0961V15.1109C28.7052 16.3206 32.9333 18.354 32.9333 24.0667H38C38 20.1627 35.5526 19.0341 33.5104 18.0923C32.2674 17.519 31.1745 17.015 30.875 15.9966V15.0936C31.2309 14.8935 32.2505 13.5181 32.3569 12.444C32.6368 12.4199 33.0787 12.1308 33.2079 10.9794C33.2776 10.3613 32.9991 10.0135 32.8319 9.90326C32.8319 9.90326 33.25 9.0022 33.25 7.91667C33.25 5.738 32.4951 3.87917 30.875 3.87917C30.875 3.87917 30.3126 2.53086 28.5 2.53086ZM7.125 3.87917C7.125 3.87917 7.6874 2.53333 9.5 2.53333C10.1397 2.53333 10.6844 2.64702 11.1848 2.81042C10.915 3.68948 10.7667 4.65247 10.7667 5.7C10.7667 6.34727 10.8748 6.9656 11.0116 7.4862C10.8241 8.03466 10.7586 8.64183 10.8384 9.2625C11.0157 10.6558 11.5585 11.6038 12.2387 12.1991C12.4363 12.6779 12.7068 13.134 12.9982 13.5672C12.6384 14.3069 12.1119 14.9606 11.875 15.0936V15.1109C9.2948 16.3219 5.06667 18.354 5.06667 24.0667H0C0 20.1623 2.44791 19.0333 4.49023 18.0914C5.73296 17.5183 6.82551 17.0144 7.125 15.9966V15.0961C6.76907 14.896 5.7495 13.5206 5.6431 12.4465C5.36317 12.4224 4.92126 12.1308 4.79206 10.9794C4.72239 10.3613 4.99963 10.0122 5.1681 9.90325C5.1681 9.90325 4.75 9.00594 4.75 7.91914C4.75 5.74047 5.50493 3.87917 7.125 3.87917Z"
                  fill="white"
                />
              </svg>
            );

          case "bwp":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.38942 1.46683C6.9994 0.58444 8.91767 0 10.9615 0C16.9561 0 21.9231 4.98492 21.9231 11.0012C21.9231 17.0175 16.9561 22.0024 10.9615 22.0024C4.96695 22.0024 0 17.0175 0 11.0012C0 9.76357 0.222657 8.59469 0.59375 7.51749C0.613264 7.44786 0.629484 7.38235 0.645225 7.31879C0.670932 7.21498 0.69536 7.11633 0.730769 7.01327C0.745042 6.98175 0.760742 6.95167 0.776442 6.92159C0.792143 6.89151 0.807843 6.86143 0.822115 6.82992C1.20463 5.74126 1.59856 5.1339 1.59856 5.1339L0.274038 3.9421C0.13513 3.9421 0.136212 3.71128 0.136923 3.55956L0.137019 3.52955C0.137019 3.38058 0.308294 3.20869 0.456731 3.20869C2.56693 2.81095 4.76065 2.90682 5.28106 2.92956H5.28106H5.28107C5.33792 2.93204 5.3748 2.93366 5.38942 2.93366L5.41895 2.93354C5.54169 2.93284 5.57113 2.93267 5.70913 3.07117C5.70913 3.07117 5.84615 3.24306 5.84615 3.39204C5.84615 3.40663 5.84774 3.44487 5.8502 3.50391C5.87278 4.04754 5.96865 6.35475 5.57212 8.20507C5.57212 8.35404 5.40084 8.52594 5.2524 8.52594C5.10397 8.52594 4.98978 8.49156 4.84135 8.34258L3.65385 7.33414C3.65385 7.33414 2.46635 8.35977 2.46635 11.0012C2.43905 11.0103 2.41659 11.0065 2.39382 11.0027C2.37374 10.9993 2.35341 10.9958 2.32933 11.0012C2.32933 15.8429 6.28576 19.6647 10.9615 19.6647C15.7858 19.6647 19.5938 15.6939 19.5938 11.0012C19.5938 6.15953 15.6373 2.33776 10.9615 2.33776C9.64844 2.33776 8.47806 2.62425 7.30769 3.20869C7.15926 2.76749 7.00511 2.35495 6.71394 2.06273C6.42278 1.77051 5.97176 1.46683 5.38942 1.46683ZM27.7692 4.40048C27.7692 3.51809 28.3516 2.93366 29.2308 2.93366C30.11 2.93366 30.6923 3.51809 30.6923 4.40048V8.80097C30.6923 9.68335 30.11 10.2678 29.2308 10.2678C28.3516 10.2678 27.7692 9.68335 27.7692 8.80097V4.40048ZM15.0721 5.86731C14.9237 5.8845 14.8266 5.93034 14.7524 6.00483L11.0986 9.4427C10.5619 9.3453 10.0081 9.43697 9.63702 9.80941C9.05469 10.3938 9.05469 11.4596 9.63702 12.193C9.70046 12.2567 9.77468 12.2987 9.85113 12.342C9.87101 12.3532 9.89103 12.3645 9.91106 12.3764L10.2308 15.9976C10.2308 16.2898 10.3792 16.5935 10.9615 16.5935C11.4011 16.5935 11.6923 16.1466 11.6923 15.9976L11.9207 12.2388C11.9292 12.2331 11.9364 12.2245 11.9435 12.2159C11.9506 12.2073 11.9578 12.1987 11.9663 12.193C12.3374 11.7289 12.4745 11.1502 12.3774 10.6345L15.6202 6.87575C15.7686 6.72678 15.9114 6.29705 15.6202 6.00483C15.4032 5.85585 15.2206 5.85012 15.0721 5.86731ZM23.3846 11.0012C23.3846 9.24216 22.9279 7.48311 22.1971 5.86731H26.3077V8.80097C26.3077 10.4168 27.6208 11.7346 29.2308 11.7346C30.8407 11.7346 32.1538 10.4168 32.1538 8.80097V5.86731H33.6154C36.0989 5.86731 38 7.77533 38 10.2678V33.5995C38 36.092 36.0989 38 33.6154 38H7.30769C4.82422 38 2.92308 36.092 2.92308 33.5995V20.3981C3.80228 21.1315 4.82422 21.8363 5.84615 22.2774V33.737C5.84615 34.6194 6.42849 35.2039 7.30769 35.2039H33.6154C34.4946 35.2039 35.0769 34.6194 35.0769 33.737V14.6683H22.7909C23.2305 13.4937 23.3846 12.3191 23.3846 11.0012ZM21.9231 17.6019V20.5356H24.8462V17.6019H21.9231ZM27.7692 20.5356V17.6019H30.6923V20.5356H27.7692ZM10.2308 23.4692V26.4029H13.1538V23.4692H10.2308ZM16.0769 26.4029V23.4692H19V26.4029H16.0769ZM21.9231 23.4692V26.4029H24.8462V23.4692H21.9231ZM27.7692 26.4029V23.4692H30.6923V26.4029H27.7692ZM10.2308 29.3365V32.2702H13.1538V29.3365H10.2308ZM16.0769 32.2702V29.3365H19V32.2702H16.0769ZM21.9231 29.3365V32.2702H24.8462V29.3365H21.9231ZM27.7692 32.2702V29.3365H30.6923V32.2702H27.7692Z"
                  fill="white"
                />
              </svg>
            );

          case "ghs":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 35 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.3128 14.1842L35 34H24.1841L15.301 21.1387L4.12405 34H0L13.4771 18.4991L13.4787 18.5006L0.700311 0H11.5162L19.4998 11.56L29.5531 0H33.6772L21.3361 14.2027L21.3128 14.1842ZM29.0863 30.9091L9.88217 3.09091H6.59849L25.8181 30.9091H29.0863Z"
                  fill="white"
                />
              </svg>
            );

          case "jpy":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.52381 0H33.4762C35.9706 0 38 2.02938 38 4.52381V33.4762C38 35.9706 35.9706 38 33.4762 38H4.52381C2.02938 38 0 35.9706 0 33.4762V4.52381C0 2.02938 2.02938 0 4.52381 0ZM29.2383 16.6096C29.4491 16.6096 29.6572 16.597 29.8626 16.578V12.3527C26.5837 12.1175 23.9608 9.55338 23.6188 6.30438H19.9853C19.9853 6.30438 19.9473 23.9463 19.9473 24.0323C19.9473 26.2073 18.0265 27.921 15.8514 27.921C13.6764 27.921 11.9139 26.1585 11.9139 23.9834C11.9139 21.8084 13.6764 20.0459 15.8514 20.0459C15.9725 20.0459 16.0896 20.0619 16.2068 20.0779C16.2472 20.0835 16.2876 20.089 16.3282 20.0939V16.292C16.2906 16.2897 16.2531 16.2871 16.2155 16.2844C16.0949 16.276 15.9742 16.2676 15.8514 16.2676C11.5909 16.2676 8.13652 19.722 8.13652 23.9825C8.13652 28.243 11.5909 31.6974 15.8514 31.6974C20.112 31.6974 23.5663 28.243 23.5663 23.9825V13.5443C24.7796 15.3891 26.8651 16.6096 29.2383 16.6096Z"
                  fill="white"
                />
              </svg>
            );

          case "nok":
            return (
              <svg
                width="100%"
                height="100%"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 12C0 5.373 5.373 0 12 0C18.627 0 24 5.373 24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12ZM11.147 17.267L18.707 9.707C19.098 9.316 19.098 8.684 18.707 8.293C18.316 7.902 17.684 7.902 17.293 8.293L10.44 15.146L7.694 12.4C7.303 12.009 6.671 12.009 6.28 12.4C5.889 12.791 5.889 13.423 6.28 13.814L9.733 17.267C9.92 17.455 10.175 17.56 10.44 17.56C10.705 17.56 10.959 17.455 11.147 17.267Z"
                  fill="#F0C9FF"
                />
              </svg>
            );
          case "stn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_816)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M7.305 7.826h15.95C21.558 3.256 17.16 0 12 0a11.96 11.96 0 0 0-8.485 3.515zM7.304 16.175h15.95C21.557 20.745 17.158 24 12 24a11.96 11.96 0 0 1-8.485-3.515z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.515 3.514c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
                  ></path>
                  <path
                    fill="#000"
                    d="m15.238 9.913.518 1.594h1.676l-1.356.985.518 1.595-1.356-.986-1.356.986.518-1.595-1.357-.985h1.677zM20.456 9.913l.518 1.594h1.676l-1.356.985.518 1.595-1.356-.986-1.357.986.518-1.595-1.356-.985h1.677z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_816">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          case "chf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_824)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M18.26 9.913h-4.174V5.74H9.914v4.174H5.739v4.174h4.174v4.174h4.173v-4.174h4.174z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_824">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "brl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_835)">
                  <path
                    fill="#6DA544"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 4.696 21.914 12 12 19.305 2.087 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M9.913 11.74c-.726 0-1.426.11-2.085.315a4.173 4.173 0 0 0 7.59 2.34 7.03 7.03 0 0 0-5.505-2.655M16.097 12.8q.076-.39.077-.8a4.174 4.174 0 0 0-8.01-1.647 8.6 8.6 0 0 1 7.933 2.447"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_835">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "czk":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_842)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M10.957 12s-7.435 8.486-7.442 8.485A11.96 11.96 0 0 0 12 23.999c6.628 0 12-5.372 12-12z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M3.515 3.515c-4.686 4.686-4.686 12.284 0 16.97L12.001 12z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_842">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "gip":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_846)">
                  <path
                    fill="#F9F9F9"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24c5.16 0 9.558-3.256 11.253-7.825H.746C2.442 20.745 6.84 24 12 24M16.696 9.914V8.348h.521V7.305h-1.043v.522H15.13v-.522h-1.043v1.043h.522v1.566h-1.044V6.26h.522V5.218h-1.044v.522h-.521v-.522h-1.044v.522h-.522v-.522H9.913v1.043h.522v3.653H9.39V8.348h.522V7.305H8.869v.522H7.826v-.522H6.783v1.043h.521v1.566H6.261v4.174h11.478V9.914z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 13.565a1.565 1.565 0 0 0-.522 3.041v2.177H9.913v2.086h2.609v-4.263a1.566 1.566 0 0 0-.522-3.04m0 2.087a.522.522 0 1 1 0-1.043.522.522 0 0 1 0 1.043"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_846">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mro":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_857)">
                  <path
                    fill="#496E2D"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 13.864a4.175 4.175 0 0 1-4.077-3.28 4.174 4.174 0 1 0 8.154 0A4.175 4.175 0 0 1 12 13.864"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 8.348.388 1.196h1.258l-1.018.739.389 1.195L12 10.74l-1.017.74.388-1.196-1.017-.74h1.257z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_857">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "omr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_862)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M0 12c0 4.549 2.53 8.506 6.261 10.541V1.46A12 12 0 0 0 .001 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.254 16.175c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174H.747A12 12 0 0 0 0 12.001c0 1.468.264 2.874.747 4.174L12 17.22z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.826H.747C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M0 12c0 5.544 3.76 10.21 8.87 11.586V.413C3.76 1.79 0 6.455 0 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M7.342 5.282 6.235 4.175l-.738.738-.738-.738-1.107 1.107.738.737-.738.738L4.76 7.864l.738-.738.738.738 1.107-1.107-.738-.738z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_862">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "sar":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_870)">
                  <path
                    fill="#6DA544"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M6.783 14.348c0 .864.7 1.565 1.565 1.565h4.696c0 .72.584 1.304 1.304 1.304h1.565c.72 0 1.305-.584 1.305-1.304v-1.565zM17.347 6.783v3.652c0 .576-.468 1.044-1.043 1.044v1.565a2.61 2.61 0 0 0 2.609-2.609V6.783zM6.13 10.435c0 .575-.468 1.043-1.043 1.043v1.566a2.61 2.61 0 0 0 2.609-2.609V6.783H6.13z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M16.566 6.783H15v3.652h1.566zM12.652 8.87a.261.261 0 0 1-.522 0V6.783h-1.565V8.87a.261.261 0 0 1-.522 0V6.783H8.478V8.87c0 1.007.82 1.826 1.826 1.826.388 0 .748-.122 1.044-.329a1.82 1.82 0 0 0 1.274.314c-.111.457-.523.798-1.013.798v1.565a2.61 2.61 0 0 0 2.608-2.609V6.783h-1.565z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M10.826 11.478H8.478v1.565h2.348z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_870">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "syp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_879)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0C6.84 0 2.442 3.255.746 7.824h22.507C21.558 3.255 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 24c5.16 0 9.558-3.256 11.253-7.826H.746C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="m7.17 9.13.648 1.993h2.095l-1.695 1.232.647 1.992-1.695-1.231-1.695 1.232.647-1.993-1.695-1.232h2.096zM16.83 9.13l.648 1.993h2.095l-1.695 1.232.647 1.992-1.695-1.231-1.695 1.232.647-1.993-1.695-1.232h2.096z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_879">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "cdf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_923)">
                  <path
                    fill="#FFDA44"
                    d="M22.667 6.498a12 12 0 0 0-2.182-2.983c-.9-.9-1.909-1.627-2.983-2.182L9.048 9.05l-7.716 8.454a12 12 0 0 0 2.182 2.983c.9.9 1.909 1.628 2.983 2.182l8.454-7.716z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.515 20.486q.756.755 1.604 1.347L21.833 5.118a12.1 12.1 0 0 0-2.951-2.951L2.167 18.88q.592.848 1.348 1.604"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M3.514 3.514C-.272 7.3-.998 12.986 1.332 17.502l16.17-16.17C12.986-.997 7.3-.27 3.514 3.515M20.486 20.485c3.785-3.786 4.512-9.472 2.181-13.988l-16.17 16.17c4.517 2.33 10.203 1.604 13.988-2.182"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m6.395 3.651.648 1.993h2.095L7.443 6.876l.647 1.993-1.695-1.232L4.7 8.869l.647-1.993-1.695-1.232h2.096z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_923">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "grd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_930)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 8.87h11.586a12 12 0 0 0-1.348-3.13H12zM4.53 21.391h14.94a12 12 0 0 0 2.77-3.13H1.761a12 12 0 0 0 2.769 3.13M4.174 2.904A12 12 0 0 0 1.762 5.74h2.412zM12 12V8.87H7.304V12h-3.13V8.87H.414A12 12 0 0 0 0 12c0 1.083.144 2.132.414 3.13h23.173c.269-.998.413-2.047.413-3.13z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 0c-1.666 0-3.253.34-4.695.955V5.74H12V2.61h7.47A11.95 11.95 0 0 0 12 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_930">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "jod":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_938)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M7.304 7.826h15.95C21.557 3.256 17.16 0 12 0a11.96 11.96 0 0 0-8.485 3.515z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M7.304 16.174h15.95c-1.696 4.57-6.094 7.827-11.254 7.827a11.96 11.96 0 0 1-8.485-3.516z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.515 3.514c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m4.763 9.392.658 1.377 1.488-.344-.666 1.374 1.196.948-1.49.336.005 1.526-1.191-.955-1.191.955.004-1.526-1.489-.336 1.196-.948-.666-1.374 1.487.344z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_938">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mur":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_944)">
                  <path
                    fill="#D80027"
                    d="m1.459 6.26 10.54 1.044L22.542 6.26A12 12 0 0 0 12 0C7.45 0 3.494 2.53 1.459 6.26"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m1.459 17.738 10.54 1.044 10.542-1.044C23.47 16.034 24 14.078 24 12l-12-1.043-12 1.043c0 2.08.529 4.034 1.459 5.74"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M1.459 6.261a11.95 11.95 0 0 0-1.46 5.74h24c0-2.08-.528-4.035-1.458-5.74H1.459"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24c4.548 0 8.505-2.531 10.54-6.261H1.46a12 12 0 0 0 10.54 6.26"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_944">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "pkr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_949)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M0 12c0 4.549 2.53 8.506 6.261 10.541V1.46A12 12 0 0 0 .001 12"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M12 0C9.92 0 7.965.53 6.26 1.46v21.082C7.966 23.472 9.92 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M17.13 13.986a3.391 3.391 0 1 1-2.425-6.112 4.174 4.174 0 1 0 3.495 4.837 3.4 3.4 0 0 1-1.07 1.275M17.066 7.827l.855.922 1.141-.529-.612 1.098.855.922-1.234-.243-.612 1.098-.15-1.248-1.234-.243 1.141-.528z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_949">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "twd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_963)">
                  <path
                    fill="#D80027"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 12V0C5.373 0 0 5.373 0 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m10.435 7.023-1.466.69.78 1.419-1.59-.305-.202 1.608-1.109-1.182-1.108 1.182-.202-1.608-1.591.305.78-1.42-1.465-.689 1.465-.69-.78-1.419 1.591.305.202-1.608 1.108 1.183L7.957 3.61l.201 1.608 1.592-.305-.78 1.42z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M6.849 9.257a2.234 2.234 0 1 0 0-4.468 2.234 2.234 0 0 0 0 4.468"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M6.848 8.214c-.656 0-1.19-.534-1.19-1.19 0-.657.534-1.19 1.19-1.19s1.19.533 1.19 1.19-.534 1.19-1.19 1.19"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_963">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "aoa":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_969)">
                  <path
                    fill="#D80027"
                    d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12c-.522 0-12 1.565-12 1.565z"
                  ></path>
                  <path
                    fill="#000"
                    d="M24 12c0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m10.354 9.544 1.017.738-.387 1.195L12 10.738l1.018.738-.39-1.195 1.017-.74-1.257.001-.39-1.195-.387 1.196z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M15 6.803a5.96 5.96 0 0 0-3-.802v1.565a4.4 4.4 0 0 1 2.217.593 4.44 4.44 0 0 1 1.623 6.058 4.44 4.44 0 0 1-6.058 1.623A4.4 4.4 0 0 1 8.3 14.442l-1.306.863A5.96 5.96 0 0 0 9 17.195 6.007 6.007 0 0 0 17.196 15 6.007 6.007 0 0 0 15 6.803"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M8.54 10.956a1.565 1.565 0 0 0 .622 2.124l5.083 2.778c-.345.632-.162 1.401.47 1.747l1.373.751a1.304 1.304 0 0 0 1.77-.518l.752-1.373z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_969">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "dkk":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_998)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M9.392 10.435h14.507C23.132 4.547 18.097 0 12.001 0c-.896 0-1.77.1-2.61.285zM6.261 10.436V1.46a12 12 0 0 0-6.159 8.976zM6.26 13.566H.103A12 12 0 0 0 6.26 22.54zM9.392 13.566v10.15c.84.185 1.713.284 2.609.284 6.096 0 11.13-4.547 11.898-10.434z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_998">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          // case "grl":
          //   return (
          //     <svg
          //       xmlns="http://www.w3.org/2000/svg"
          //       width="24"
          //       height="24"
          //       fill="none"
          //       viewBox="0 0 24 24"
          //     >
          //       <g clipPath="url(#clip0_0_1005)">
          //         <path
          //           fill="#F0F0F0"
          //           d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12c-.522 0-12 1.565-12 1.565z"
          //         ></path>
          //         <path
          //           fill="#D80027"
          //           d="M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12"
          //         ></path>
          //         <path
          //           fill="#F0F0F0"
          //           d="M8.348 17.74a5.74 5.74 0 1 0 0-11.479 5.74 5.74 0 0 0 0 11.479"
          //         ></path>
          //         <path
          //           fill="#D80027"
          //           d="M2.608 12a5.74 5.74 0 0 1 11.479 0"
          //         ></path>
          //       </g>
          //       <defs>
          //         <clipPath id="clip0_0_1005">
          //           <path fill="#fff" d="M0 0h24v24H0z"></path>
          //         </clipPath>
          //       </defs>
          //     </svg>
          //   );

          case "kzt":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1010)">
                  <path
                    fill="#338AF3"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M18.783 12.13H5.218c0 .937.815 1.696 1.752 1.696h-.057c0 .936.76 1.695 1.696 1.695 0 .937.76 1.696 1.696 1.696h3.391c.937 0 1.696-.759 1.696-1.696.936 0 1.695-.759 1.695-1.695h-.056c.936 0 1.752-.76 1.752-1.696"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M16.696 9.914a4.696 4.696 0 0 1-9.391 0"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m15.587 9.912-1.466.69.78 1.42-1.591-.305-.202 1.607L12 12.142l-1.109 1.182-.201-1.607-1.592.304.78-1.42-1.465-.689 1.466-.689-.78-1.42 1.59.305.202-1.608L12 7.683 13.108 6.5l.202 1.608 1.591-.304-.78 1.42z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1010">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mxn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1015)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12a12 12 0 0 0-6.783-10.81V22.81A12 12 0 0 0 24 11.999"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M0 12a12 12 0 0 0 6.783 10.809V1.19A12 12 0 0 0 0 12M8.87 12a3.13 3.13 0 1 0 6.26 0v-1.044H8.87z"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M16.174 9.913h-3.131a1.044 1.044 0 0 0-2.087 0h-3.13c0 .577.502 1.044 1.078 1.044h-.035c0 .576.467 1.043 1.044 1.043 0 .577.467 1.044 1.043 1.044h2.087c.576 0 1.043-.467 1.043-1.044.577 0 1.044-.467 1.044-1.043h-.035c.577 0 1.079-.467 1.079-1.044"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1015">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "rsd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1025)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 0C5.373 0 0 5.373 0 12c0 1.468.264 2.874.746 4.174h22.508c.482-1.3.746-2.706.746-4.174 0-6.627-5.373-12-12-12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0C6.84 0 2.442 3.257.747 7.826h22.507C21.558 3.256 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.103 6.783v5.986c0 3.406 4.449 4.449 4.449 4.449S12 16.175 12 12.769V6.783z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M4.942 7.826h5.218V5.74l-1.044.522-1.565-1.565L5.986 6.26 4.942 5.74zM10.956 13.603 7.565 10.21l-3.392 3.392 1.107 1.106 2.285-2.284 2.284 2.284z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M10.956 10.434H9.374A1.043 1.043 0 1 0 7.55 9.42a1.043 1.043 0 1 0-1.823 1.014H4.173c0 .576.502 1.044 1.079 1.044h-.035c0 .576.467 1.043 1.043 1.043 0 .51.367.934.85 1.025l-.821 1.856a3.38 3.38 0 0 0 2.552 0l-.822-1.856c.484-.09.85-.515.85-1.025.576 0 1.044-.467 1.044-1.043h-.035c.576 0 1.078-.468 1.078-1.044"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1025">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "tjs":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1035)">
                  <path
                    fill="#F0F0F0"
                    d="M1.19 6.782A11.95 11.95 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.217L12 18.26l10.81-1.044A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 5.738z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M1.191 17.218A12 12 0 0 0 12.001 24a12 12 0 0 0 10.808-6.782z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M1.191 6.782H22.81A12 12 0 0 0 12-.001 12 12 0 0 0 1.191 6.782"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M9.913 15.132h4.174v-1.774l-.835.417L12 12.523l-1.252 1.252-.835-.418zM7.525 13.044l.194.598h.629l-.509.37.195.597-.51-.37-.508.37.195-.598-.509-.37h.629zM8.127 10.958l.195.598h.628l-.508.369.194.598-.509-.37-.508.37.194-.598-.509-.37h.629zM9.849 9.393l.194.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.598-.508-.37h.628zM16.475 13.044l-.194.598h-.629l.509.37-.195.597.509-.37.508.37-.194-.598.509-.37h-.629zM15.873 10.958l-.195.598h-.628l.508.369-.194.598.509-.37.508.37-.194-.598.509-.37h-.629zM14.151 9.393l-.194.598h-.629l.509.37-.194.597.508-.37.509.37-.194-.598.508-.37h-.629zM12 8.61l.195.597h.628l-.508.37.194.598-.509-.37-.508.37.194-.598-.508-.37h.628z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1035">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bnd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1063)">
                  <path
                    fill="#F0F0F0"
                    d="M12 23.998C18.627 23.998 24 18.626 24 11.999 23.999 5.373 18.627.001 12 .001 5.374.001.002 5.373.002 12c0 6.627 5.372 11.999 11.998 11.999"
                  ></path>
                  <path
                    fill="#000"
                    d="M1.61 6.001A12 12 0 0 0 .402 8.918l20.066 11.586A12 12 0 0 0 22.391 18z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M17.999 1.61C13.198-1.163 7.279-.24 3.532 3.496l20.065 11.585C24.96 9.969 22.8 4.38 18 1.609M6 22.39c4.801 2.772 10.721 1.848 14.468-1.888L.402 8.917C-.96 14.03 1.2 19.618 6 22.39"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M15.39 10.696a3.39 3.39 0 1 1-6.373-1.613 4.173 4.173 0 1 0 5.966 0c.26.48.408 1.03.408 1.613"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12.783 6.784h-1.565v7.825h1.565z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M14.608 8.348H9.391c0 .36.314.652.674.652h-.021c0 .36.292.652.652.652 0 .36.292.653.652.653h1.304c.36 0 .652-.292.652-.653.36 0 .652-.291.652-.652h-.022c.36 0 .674-.292.674-.652M15.652 15.13H8.35v1.565h7.303z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M16.695 15.651h-3.13v1.565h3.13zM10.435 15.651h-3.13v1.565h3.13z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1063">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "dji":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1076)">
                  <path
                    fill="#338AF3"
                    d="M10.956 13.044s-7.434-9.53-7.442-9.529A11.96 11.96 0 0 1 12 .001c6.627 0 12 5.372 12 12z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M10.956 12s-7.434 8.486-7.442 8.485A11.96 11.96 0 0 0 12 23.999c6.627 0 12-5.372 12-12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M3.514 3.515c-4.686 4.686-4.686 12.284 0 16.97L12 12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m4.856 8.87.777 2.39h2.515L6.114 12.74l.777 2.391-2.035-1.478-2.034 1.478.777-2.391-2.034-1.478h2.514z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1076">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "djf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1081)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M5.236 2.087A11.94 11.94 0 0 1 12 0c2.509 0 4.837.77 6.763 2.087L12 2.609z"
                  ></path>
                  <path fill="#0052B4" d="m12 12-.765-.766-.204.364z"></path>
                  <path
                    fill="#496E2D"
                    d="M3.515 3.515c-4.686 4.686-4.686 12.284 0 16.97 1.937-1.936 3.8-3.798 8.486-8.485zM20.486 3.516c4.686 4.686 4.686 12.284 0 16.97L12 12.002z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M12 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 7.826.935 2.88h3.028l-2.45 1.78.936 2.88-2.45-1.78-2.449 1.78.936-2.88-2.45-1.78h3.028z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M12.004 0h-.008a11.96 11.96 0 0 0-8.48 3.514h16.969A11.96 11.96 0 0 0 12.005 0M3.516 20.486A11.96 11.96 0 0 0 12.001 24c3.313 0 6.313-1.343 8.484-3.514z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 1.304.195.598h.628l-.508.37.194.597L12 2.5l-.508.37.194-.597-.509-.37h.629zM9.09 1.304l.195.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.597-.508-.37h.628zM14.91 1.304l.194.598h.629l-.509.37.195.597-.509-.37-.509.37.195-.597-.509-.37h.629zM12 21.13l.195.598h.628l-.508.37.194.597-.509-.37-.508.37.194-.598-.509-.37h.629zM9.09 21.13l.195.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.598-.508-.37h.628zM14.91 21.13l.194.598h.629l-.509.37.195.597-.509-.37-.509.37.195-.598-.509-.37h.629zM3.657 11.802a1.043 1.043 0 1 1-1.764 1.116c-.558-.881-.234-2.321-.234-2.321s1.44.323 1.998 1.205"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M3.054 13.323a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.043"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1081">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "kes":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1104)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 0A12 12 0 0 0 1.191 6.781H22.81A12 12 0 0 0 12-.001"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M12 24a12 12 0 0 1-10.809-6.782H22.81A12 12 0 0 1 12 24"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M23.434 8.347H.566A12 12 0 0 0 0 12c0 1.274.2 2.5.567 3.652h22.866A12 12 0 0 0 24 12c0-1.273-.199-2.5-.567-3.652"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m15.737 5.545-1.421-.656L12 10.132 9.685 4.89l-1.421.656L11.138 12l-2.874 6.454 1.42.656L12 13.867l2.316 5.243 1.42-.656L12.863 12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12.965 6.163c-.55-.6-.965-.946-.965-.946s-.415.345-.965.946v11.673c.55.6.965.946.965.946s.415-.345.965-.946z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M9.392 8.402v7.196a12.6 12.6 0 0 0 1.826 2.434V5.968a12.6 12.6 0 0 0-1.826 2.434M14.609 8.403a12.6 12.6 0 0 0-1.826-2.434v12.064a12.6 12.6 0 0 0 1.826-2.434z"
                  ></path>
                  <path
                    fill="#000"
                    d="M14.609 8.4v7.197c.588-1.043 1.043-2.276 1.043-3.598S15.197 9.444 14.61 8.4M9.391 8.4v7.197c-.588-1.043-1.043-2.276-1.043-3.598S8.803 9.444 9.39 8.4"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1104">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "tzs":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1135)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M3.515 20.486q.756.755 1.604 1.347L21.833 5.12a12 12 0 0 0-2.952-2.952L2.167 18.882q.592.846 1.348 1.603"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M3.515 3.514C-.271 7.3-.998 12.985 1.333 17.5L17.502 1.332C12.986-.998 7.3-.272 3.515 3.514"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M20.485 20.485c3.786-3.786 4.512-9.471 2.182-13.987L6.497 22.667c4.517 2.33 10.202 1.604 13.988-2.182"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1135">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bgn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1148)">
                  <path
                    fill="#496E2D"
                    d="M24 12c0-1.467-.264-2.873-.746-4.173L12 7.305.746 7.827A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.173L12 16.696l11.254-.521c.482-1.3.746-2.706.746-4.174"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24c5.16 0 9.558-3.257 11.253-7.826H.746C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M.746 7.825h22.508C21.557 3.255 17.16 0 12 0S2.442 3.256.746 7.825"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1148">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mdl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1204)">
                  <path
                    fill="#FFDA44"
                    d="M17.217 1.191A11.95 11.95 0 0 0 12 .001c-1.87 0-3.64.427-5.218 1.19L5.74 12.001 6.782 22.81A11.95 11.95 0 0 0 12 24c1.87 0 3.64-.427 5.217-1.19L18.261 12z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M6.783 1.192A12 12 0 0 0 0 12.001 12 12 0 0 0 6.783 22.81z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M17.217 1.192V22.81A12 12 0 0 0 24 12a12 12 0 0 0-6.783-10.809"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M16.174 9.442h-2.87a1.304 1.304 0 0 0-2.609 0h-2.87c0 .71.619 1.284 1.328 1.284H9.11c0 .71.575 1.285 1.284 1.285 0 .628.451 1.15 1.047 1.261l-1.012 2.285a4.16 4.16 0 0 0 3.141 0l-1.012-2.285a1.284 1.284 0 0 0 1.047-1.261c.71 0 1.284-.575 1.284-1.285h-.042c.709 0 1.327-.575 1.327-1.284"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 11.218 10.304 12v1.566L12 14.609l1.696-1.043V12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M13.696 10.434h-3.392V12h3.392z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1204">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "pab":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1211)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M0 12c0 6.627 5.373 12 12 12V12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0c6.627 0 12 5.373 12 12H12z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="m7.144 4.175.777 2.391h2.514L8.401 8.044l.777 2.392-2.034-1.478-2.035 1.478.777-2.392-2.034-1.478h2.515z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m16.857 13.565.777 2.391h2.515l-2.035 1.478.777 2.392-2.034-1.478-2.034 1.478.777-2.392-2.034-1.478h2.514z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1211">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "sll":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1217)">
                  <path
                    fill="#F0F0F0"
                    d="M23.253 16.174c.483-1.3.747-2.706.747-4.174 0-1.467-.264-2.874-.747-4.173L12 6.783.746 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 17.218z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 24c5.16 0 9.558-3.256 11.253-7.826H.746C2.442 20.745 6.84 24.002 12 24.002"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 0C6.84 0 2.442 3.257.746 7.826h22.508C21.557 3.256 17.16 0 12 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1217">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "thb":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1221)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M23.254 7.826H.747A12 12 0 0 0 0 12c0 1.468.264 2.874.747 4.174h22.507c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12.001 0a11.97 11.97 0 0 0-9.096 4.173h18.193A11.97 11.97 0 0 0 12 0M21.097 19.826H2.904A11.97 11.97 0 0 0 12 24c3.637 0 6.896-1.618 9.097-4.174"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1221">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ars":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1227)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 0A12 12 0 0 0 1.19 6.781h21.62A12 12 0 0 0 12-.001M12 23.999a12 12 0 0 0 10.81-6.783H1.19A12 12 0 0 0 12.001 24"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m15.587 12-1.466.69.78 1.419-1.591-.305-.202 1.608L12 14.23l-1.109 1.182-.201-1.608-1.592.305.78-1.42L8.414 12l1.466-.69-.78-1.419 1.59.305.202-1.608L12 9.771l1.108-1.183.202 1.608 1.591-.305-.78 1.42z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1227">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "dop":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1237)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M.414 15.131a12.02 12.02 0 0 0 8.456 8.456v-8.456z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M8.87.413A12.02 12.02 0 0 0 .412 8.87H8.87z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.587 8.87A12.02 12.02 0 0 0 15.13.414V8.87z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M15.13 23.587a12.02 12.02 0 0 0 8.457-8.456H15.13z"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M15.13 12a3.13 3.13 0 1 1-6.26 0c0-1.73 3.13-3.13 3.13-3.13s3.13 1.4 3.13 3.13"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M8.87 12a3.13 3.13 0 0 1 6.26 0"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M10.24 10.434v1.957a1.76 1.76 0 1 0 3.521 0v-1.957z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1237">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "gtq":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1246)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M24 12a12 12 0 0 0-6.783-10.809V22.81A12 12 0 0 0 23.999 12M0 12a12 12 0 0 0 6.782 10.81V1.19A12 12 0 0 0 0 12"
                  ></path>
                  <path
                    fill="#ACABB1"
                    d="M15.136 14.028 13.106 12l1.932-1.931-.088-1.02-.553-.553L12 10.893 9.602 8.495l-.553.553-.088 1.02 1.932 1.931-2.03 2.03 1.108 1.106L12 13.106l2.029 2.03z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="m14.952 9.049-1.107 1.107a2.609 2.609 0 1 1-3.69 0L9.05 9.049a4.174 4.174 0 1 0 5.903 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1246">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "kwd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1253)">
                  <path
                    fill="#F0F0F0"
                    d="M23.254 16.173c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174L12 6.782.747 7.825A12 12 0 0 0 0 12c0 1.468.264 2.874.747 4.174L12 17.217z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.827H.747C2.442 20.743 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 0C6.84 0 2.442 3.255.747 7.825h22.507C21.558 3.256 17.16-.001 12-.001"
                  ></path>
                  <path
                    fill="#000"
                    d="M3.515 3.515c-4.686 4.686-4.686 12.284 0 16.97l4.312-4.311V7.826z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1253">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "pgk":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1261)">
                  <path
                    fill="#000"
                    d="M20.485 20.486c-4.686 4.686-12.284 4.686-16.97 0-4.687-4.687-4.687-12.285 0-16.97C8.2-1.172 15.06-.435 19.747 4.252c4.687 4.686 5.425 11.546.738 16.233"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M3.515 3.515c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m9.171 16.174.195.598h.628l-.508.37.194.597-.509-.37-.508.37.194-.598-.508-.37h.628zM7.565 10.435l.324.996h1.048l-.848.616.324.997-.848-.616-.848.616.324-.997-.847-.616H7.24zM7.565 17.739l.324.996h1.048l-.848.616.324.996-.848-.616-.848.616.324-.996-.847-.616H7.24zM10.629 13.044l.324.996H12l-.847.616.324.997-.848-.616-.848.616.324-.997-.847-.616h1.047zM4.502 13.044l.324.996h1.048l-.848.616.324.997-.848-.616-.847.616.323-.997-.847-.616h1.047z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M20.088 8.886a3.1 3.1 0 0 0-1.982-.907l2.242-1.744a4.16 4.16 0 0 0-3.257-1.21 3.1 3.1 0 0 0-.801-1.372l-.886 1.77a1.304 1.304 0 1 0-1.77 1.77l-1.771.887c.395.395.87.662 1.372.802a4.16 4.16 0 0 0 1.21 3.256l1.959-2.518a.78.78 0 0 1 .548-.225c.21 0 .406.081.554.23.148.147.229.344.229.553s-.081.405-.23.553l.739.738c.345-.345.535-.804.535-1.291 0-.4-.128-.779-.363-1.093a2.09 2.09 0 0 1 .934 3.49l.738.739a3.1 3.1 0 0 0 .917-2.214c0-.836-.326-1.622-.917-2.214"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1261">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "sgd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1271)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M7.304 6.261a3.65 3.65 0 0 1 2.87-3.567 3.652 3.652 0 1 0 0 7.135 3.65 3.65 0 0 1-2.87-3.568M12 2.87l.259.797h.838l-.678.493.259.797L12 4.464l-.678.493.259-.797-.678-.493h.838z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m9.967 4.435.258.797h.839l-.678.492.259.798-.678-.493-.679.493.26-.798-.679-.492h.838zM14.033 4.435l.26.797h.837l-.678.492.26.798-.679-.493-.678.493.259-.798-.678-.492h.838zM13.25 6.783l.26.797h.838l-.678.493.259.797-.678-.492-.679.492.26-.797-.679-.493h.838zM10.749 6.783l.259.797h.838l-.678.493.259.797-.678-.492-.678.492.259-.797-.678-.493h.838z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1271">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "amd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1289)">
                  <path
                    fill="#0052B4"
                    d="M24 12c0-1.468-.264-2.874-.746-4.174L12 7.304.747 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.747 4.174L12 16.696l11.254-.522c.482-1.3.746-2.706.746-4.174"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.827H.746C2.442 20.743 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M.746 7.826h22.508C21.558 3.256 17.16 0 12 0S2.442 3.257.746 7.826"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1289">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bif":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1293)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M19.307 2.48a12.006 12.006 0 0 0-14.613 0L12 9.787zM12 14.214 4.695 21.52a12.006 12.006 0 0 0 14.613 0z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M9.787 12 2.48 4.694a12.006 12.006 0 0 0 0 14.613zM14.214 12l7.307 7.307a12.006 12.006 0 0 0 0-14.613z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 17.218a5.217 5.217 0 1 0 0-10.435 5.217 5.217 0 0 0 0 10.435"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m12 8.348.452.783h.903l-.452.782.452.783h-.903L12 11.48l-.452-.783h-.904l.452-.783-.452-.782h.904zM9.703 12.001l.452.783h.904l-.452.782.452.783h-.904l-.452.782-.451-.782h-.904l.452-.783-.452-.782h.904zM14.297 12.001l.452.783h.903l-.451.782.451.783h-.903l-.452.782-.452-.782h-.904l.452-.783-.452-.782h.904z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1293">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "kgs":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1315)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m17.868 12-2.398 1.128 1.277 2.322-2.604-.498-.33 2.63L12 15.649l-1.813 1.935-.33-2.63-2.604.497 1.277-2.322L6.131 12l2.398-1.128L7.252 8.55l2.604.498.33-2.63 1.813 1.934 1.814-1.935.33 2.63 2.604-.497-1.277 2.322z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 15.651a3.652 3.652 0 1 0 0-7.304 3.652 3.652 0 0 0 0 7.304"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M10.174 12a3 3 0 0 0-.26.014c.003.505.186.968.488 1.328.161-.434.402-.83.706-1.168a2.6 2.6 0 0 0-.934-.173M11.299 13.967a2.08 2.08 0 0 0 1.403 0A2.6 2.6 0 0 0 12 12.75c-.335.33-.582.749-.701 1.218M13.808 10.957a2.086 2.086 0 0 0-3.615 0 3.6 3.6 0 0 1 1.808.491 3.6 3.6 0 0 1 1.807-.49M12.893 12.174c.303.338.544.734.705 1.168.303-.36.486-.822.489-1.328a2.6 2.6 0 0 0-1.194.16"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1315">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mnt":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1324)">
                  <path
                    fill="#0052B4"
                    d="M12 24c1.467 0 2.874-.263 4.174-.746l.521-11.253L16.174.747A12 12 0 0 0 12 .001c-1.468 0-2.874.264-4.174.746l-.522 11.254.522 11.253c1.3.483 2.706.747 4.174.747"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M0 12c0 5.16 3.256 9.558 7.826 11.254V.746C3.256 2.442 0 6.84 0 12M16.174.746v22.507C20.744 21.558 24 17.16 24 12 24 6.84 20.743 2.44 16.174.746"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M6.783 11.999H5.739v4.174h1.044zM2.609 11.999H1.565v4.174H2.61zM4.174 14.609a1.043 1.043 0 1 0 0-2.087 1.043 1.043 0 0 0 0 2.086M4.174 10.434a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.044M5.217 15.129H3.13v1.043h2.087zM5.217 10.955H3.13V12h2.087zM4.174 6.26l.37 1.137H5.74l-.968.703.37 1.137-.968-.703-.967.703.37-1.137-.968-.703h1.196z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1324">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "prb":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1337)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0A12 12 0 0 0 1.191 6.783H22.81A12 12 0 0 0 12 0"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 24a12 12 0 0 0 10.81-6.782H1.19a12 12 0 0 0 10.81 6.783"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="m14.951 8.527-1.107 1.106a2.609 2.609 0 1 1-3.69 0L9.05 8.527a4.174 4.174 0 1 0 5.903 0"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 9.913.389 1.195h1.257l-1.017.74.388 1.195L12 12.304l-1.017.74.388-1.197-1.017-.739h1.257z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1337">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "tmt":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1358)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M19.304 5.74a8 8 0 0 0-.156 1.617 7.86 7.86 0 0 0 4.591 7.139c.17-.806.261-1.64.261-2.496 0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c4.11 0 7.737-2.067 9.9-5.217H6.783v-1.566h16.026q.247-.509.445-1.043H6.783z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m8.816 6.261.259.797h.838l-.678.493.259.797-.678-.492-.678.492.259-.797-.679-.493h.839zM5.411 12l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.323-.997-.847-.615h1.048zM5.411 3.652l.324.997h1.048l-.848.616.324.996-.848-.616-.847.616.323-.996-.847-.616h1.048zM2.802 8.348l.324.996h1.048l-.848.616.324.996-.848-.616-.847.616.324-.996-.848-.616h1.048z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1358">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "awg":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1366)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 24c3.637 0 6.896-1.618 9.097-4.174H2.903A11.97 11.97 0 0 0 12 24M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13M.954 16.696q.347.816.807 1.565H22.24q.459-.748.807-1.565z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M5.499 7.57 3.154 6.533 5.5 5.5l1.035-2.345L7.568 5.5l2.345 1.034L7.568 7.57 6.534 9.914z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m6.534 4.447.639 1.448 1.448.64-1.448.638-.64 1.448-.638-1.448-1.448-.639 1.448-.639z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1366">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "khr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1374)">
                  <path
                    fill="#D80027"
                    d="M0 12c0 2.08.53 4.035 1.46 5.74L12 18.784l10.541-1.044c.93-1.705 1.46-3.66 1.46-5.74 0-2.078-.53-4.033-1.46-5.738l-10.54-1.044L1.458 6.262A11.95 11.95 0 0 0 0 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M1.46 6.261h21.08A12 12 0 0 0 12 .001C7.451 0 3.494 2.53 1.46 6.26M12 24c4.549 0 8.506-2.53 10.54-6.26H1.46A12 12 0 0 0 12 24"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M16.174 14.347v-1.565h-1.043v-2.087l-1.044-1.043-1.043 1.043V8.608L12 7.565l-1.043 1.043v2.087L9.913 9.652 8.87 10.695v2.087H7.827v1.565H6.783v1.566h10.435v-1.566z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1374">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "lak":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1394)">
                  <path
                    fill="#D80027"
                    d="M22.81 6.782A12 12 0 0 0 12-.001 12 12 0 0 0 1.19 6.782L12 7.825zM1.19 17.216A12 12 0 0 0 12 24a12 12 0 0 0 10.81-6.783L12 16.173z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M22.809 6.782H1.19A11.95 11.95 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.218H22.81a11.95 11.95 0 0 0 1.19-5.218c0-1.87-.427-3.64-1.19-5.217"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1394">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "pen":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1408)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12.002c0-5.16-3.256-9.559-7.826-11.254v22.507C20.744 21.56 24 17.161 24 12.002M0 12c0 5.16 3.257 9.559 7.826 11.254V.747C3.256 2.443 0 6.841 0 12.001"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1408">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "top":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1423)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M7.826 6.261V4.696H6.261v1.565H4.696v1.566H6.26v1.565h1.565V7.827h1.565V6.26z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0v12H0c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1423">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          case "egp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1449)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0C6.84 0 2.442 3.256.747 7.826h22.507C21.558 3.256 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 24c5.16 0 9.558-3.256 11.254-7.826H.747C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M16.174 10.696h-3.13a1.043 1.043 0 0 0-2.088 0h-3.13c0 .576.502 1.043 1.078 1.043H8.87c0 .576.468 1.044 1.044 1.044 0 .576.467 1.043 1.043 1.043h2.087c.577 0 1.044-.467 1.044-1.043.576 0 1.043-.468 1.043-1.044h-.034c.576 0 1.078-.467 1.078-1.043"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1449">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "gnf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1454)">
                  <path
                    fill="#FFDA44"
                    d="M16.174.746A12 12 0 0 0 12 0c-1.467 0-2.874.264-4.173.746L7.305 12l.521 11.254c1.3.482 2.707.746 4.174.746s2.874-.264 4.174-.747L16.696 12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M0 12c0 5.16 3.257 9.558 7.826 11.254V.747C3.256 2.442 0 6.84 0 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M24 12c0-5.16-3.257-9.558-7.826-11.253v22.507C20.744 21.558 24 17.16 24 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1454">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "xcr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1463)">
                  <path
                    fill="#0052B4"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path fill="#F0F0F0" d="M11.968 12h.033v-.032z"></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 6.261V.001h-.002C5.373 0 0 5.373 0 12h6.261V8.474L9.787 12h2.181l.033-.032V9.787L8.475 6.26z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M6.071 1.565a12.06 12.06 0 0 0-4.506 4.506v5.93h3.13V4.695H12v-3.13z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 10.524 7.738 6.261H6.261L12.001 12z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M13.565 6.26V12c0 2.795 3.652 3.652 3.652 3.652S20.87 14.795 20.87 12V6.26z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M13.565 12c0 2.795 3.652 3.651 3.652 3.651S20.87 14.795 20.87 12z"
                  ></path>
                  <path
                    fill="#000"
                    d="M18.782 8.87H17.74V7.825h-1.044v1.043h-1.043v1.044h1.043v3.13h1.044v-3.13h1.043z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1463">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "php":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1475)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0v12l-8.485 8.485A11.96 11.96 0 0 0 12 24c6.628 0 12-5.373 12-12S12 0 12 0"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 0a11.96 11.96 0 0 0-8.485 3.515L12 12h12c0-6.627-5.372-12-12-12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m8.217 12-1.465-.69.78-1.419-1.591.305-.202-1.608L4.631 9.77 3.522 8.588l-.202 1.608-1.59-.305.78 1.42L1.044 12l1.466.69-.78 1.418 1.59-.304.202 1.608 1.109-1.183 1.108 1.183.202-1.608 1.591.305-.78-1.42zM3.2 4.695l.489.682.799-.253-.498.674.487.682-.795-.265-.497.675.006-.839-.795-.265.799-.253zM3.2 17.11l.489.681.799-.253-.498.675.487.681-.795-.265-.497.675.006-.838-.795-.265.799-.253zM10.156 10.903l-.487.682-.8-.253.498.674-.487.682.795-.265.498.675-.007-.839.796-.264-.8-.254z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1475">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ttd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1492)">
                  <path
                    fill="#F0F0F0"
                    d="M6.498 1.332a12 12 0 0 0-2.984 2.182c-.9.9-1.627 1.909-2.181 2.983l7.716 8.454 8.453 7.716a12 12 0 0 0 2.984-2.182c.9-.9 1.627-1.909 2.182-2.983l-7.716-8.454z"
                  ></path>
                  <path
                    fill="#000"
                    d="M20.486 20.486a12 12 0 0 0 1.347-1.604L5.118 2.167a12.1 12.1 0 0 0-2.951 2.952L18.88 21.834q.848-.594 1.604-1.348"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.514 20.487c3.786 3.786 9.472 4.512 13.988 2.181L1.332 6.498c-2.33 4.517-1.604 10.203 2.182 13.988M20.485 3.515C16.7-.271 11.013-.998 6.497 1.333l16.17 16.17c2.33-4.517 1.604-10.202-2.182-13.988"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1492">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "cny":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1503)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12.001a12 12 0 0 0-6.782-10.81v21.62A12 12 0 0 0 24.001 12M0 12a12 12 0 0 0 6.783 10.81V1.19A12 12 0 0 0 0 12.001M14.088 13.566l2.086-1.043L15.131 12v-1.043L13.044 12l1.044-2.087h-1.044l-1.043-1.565-1.044 1.565H9.914l1.043 2.087-2.087-1.043V12l-1.043.522 2.087 1.043-.522 1.044h2.087v1.565h1.043V14.61h2.087z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1503">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "gyd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1512)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12-.001c-2.122 0-4.114.551-5.843 1.517v20.966A11.94 11.94 0 0 0 12 23.999c6.627 0 12-5.373 12-12s-5.373-12-12-12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M6.192 1.498A12 12 0 0 0 4.285 2.81l9.19 9.19-9.19 9.191a12 12 0 0 1 1.907 1.312L24 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M5.178 2.127q-.55.38-1.052.817L12 12l-7.874 9.055q.503.437 1.052.817L21.946 12z"
                  ></path>
                  <path
                    fill="#000"
                    d="M4.285 2.81q-.4.336-.77.705l7.441 8.486-7.441 8.485q.37.369.77.705l9.19-9.19z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.515 3.514c-4.687 4.687-4.687 12.285 0 16.97L12 12z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1512">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "lbp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1519)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0A12 12 0 0 0 1.19 6.781h21.62A12 12 0 0 0 12-.001M12 24a12 12 0 0 0 10.81-6.783H1.19a12 12 0 0 0 10.81 6.782"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M15.13 14.086 12 8.347l-3.13 5.74h2.348v1.564h1.565v-1.565z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1519">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mad":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1525)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M19.092 9.848h-5.418L12 4.695l-1.674 5.153H4.91l4.383 3.184-1.675 5.153L12 15l4.383 3.185-1.674-5.153zm-8.574 2.785.566-1.742h1.832l.566 1.742L12 13.71zm2.06-2.785h-1.155L12 8.072zm1.792 2.14-.357-1.097h1.867zm-4.383-1.097-.356 1.098-1.51-1.098zm-.385 4.562.577-1.776.934.678zm3.286-1.098.934-.678.576 1.776z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1525">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "tnd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1546)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 17.739A5.74 5.74 0 1 0 12 6.26a5.74 5.74 0 0 0 0 11.479"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m12.707 9.805.984 1.357 1.595-.517L14.3 12l.984 1.357-1.594-.519-.986 1.356v-1.677L11.112 12l1.594-.518z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M13.304 15.39a3.391 3.391 0 1 1 1.613-6.374 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.613.408"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1546">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "azn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1552)">
                  <path
                    fill="#D80027"
                    d="M24 12c0-1.468-.264-2.874-.747-4.174L12 7.304.746 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 16.696l11.253-.522c.483-1.3.747-2.706.747-4.174"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.827H.747C2.442 20.743 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M.747 7.825h22.507C21.558 3.255 17.16 0 12 0S2.442 3.256.747 7.825"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12.26 15.391a3.391 3.391 0 1 1 1.614-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.613.408"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m14.87 9.65.449 1.264 1.21-.576-.575 1.211 1.263.45-1.263.449.576 1.21-1.211-.575-.45 1.264-.449-1.264-1.21.576.575-1.211-1.263-.45 1.263-.449-.576-1.21 1.211.575z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1552">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "kyd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1559)">
                  <path
                    fill="#0052B4"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path fill="#F0F0F0" d="M11.969 12H12v-.032z"></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 6.26V0h-.002C5.372 0 0 5.373 0 12h6.261V8.474l3.526 3.525h2.181q.016-.014.032-.032V9.786L8.475 6.26z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M17.217 8.87a2.087 2.087 0 1 0 0-4.175 2.087 2.087 0 0 0 0 4.174"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M6.07 1.565a12.06 12.06 0 0 0-4.505 4.506V12h3.13V4.696H12v-3.13z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 10.524 7.735 6.26H6.26L12 12zM20.87 6.26h-7.305v3.13h7.304z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M13.565 14.087v2.087h1.098a3.64 3.64 0 0 0 2.554 1.043c.995 0 1.896-.398 2.555-1.043h1.098v-2.087z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M13.565 8.869v3.13c0 2.796 3.652 3.653 3.652 3.653S20.87 14.795 20.87 12V8.869z"
                  ></path>
                  <path
                    fill="#F3F3F3"
                    d="M17.217 10.54c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835v1.461c.913 0 .913.835 1.826.835s.913-.835 1.826-.835.913.835 1.827.835.913-.835 1.826-.835v-1.46c-.913 0-.913.834-1.826.834-.914 0-.914-.835-1.827-.835M17.217 7.617c-.913 0-.913.834-1.826.834s-.913-.834-1.826-.834v1.46c.913 0 .913.835 1.826.835s.913-.835 1.826-.835.913.835 1.826.835.913-.835 1.827-.835v-1.46c-.914 0-.914.834-1.827.834s-.913-.834-1.826-.834"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1559">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "htg":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1586)">
                  <path
                    fill="#A2001D"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 12 0 12 0s12 5.373 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M16.174 15.13 12 14.61l-4.174.521V8.87h8.348z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 14.608a2.087 2.087 0 1 0 0-4.174 2.087 2.087 0 0 0 0 4.174"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M12 13.565a1.044 1.044 0 1 0 0-2.087 1.044 1.044 0 0 0 0 2.087"
                  ></path>
                  <path fill="#6DA544" d="M10.435 9.913h3.13L12 11.48z"></path>
                  <path
                    fill="#FFDA44"
                    d="M12.522 10.956H11.48v3.13h1.043z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M13.67 13.775h-3.34L7.826 15.13h8.348z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1586">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "lsl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1595)">
                  <path
                    fill="#F0F0F0"
                    d="M0 12c0 1.87.428 3.64 1.19 5.217L12 17.74l10.81-.522A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 6.26l-10.81.521A11.95 11.95 0 0 0 0 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24a12 12 0 0 0 10.81-6.782H1.19A12 12 0 0 0 12.001 24"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 0A12 12 0 0 0 1.191 6.781H22.81A12 12 0 0 0 12-.001"
                  ></path>
                  <path
                    fill="#000"
                    d="M12.783 11.74V8.87h-1.565v2.87l-1.89 1.89c.55.9 1.54 1.5 2.673 1.5 1.131 0 2.123-.6 2.673-1.5z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1595">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mzn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1600)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m6.486 16.696-2.971 3.79A11.96 11.96 0 0 0 12 24c4.96 0 9.217-3.01 11.045-7.304z"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M23.063 7.348C21.246 3.032 16.977.001 12 .001a11.96 11.96 0 0 0-8.485 3.515L6.52 7.348z"
                  ></path>
                  <path
                    fill="#000"
                    d="M2.609 8.826v6.304h20.978c.269-.998.413-2.047.413-3.13 0-1.099-.148-2.163-.425-3.174z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M3.514 3.514c-4.686 4.687-4.686 12.285 0 16.97L12 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m4.857 8.87.777 2.39h2.515L6.114 12.74l.777 2.391-2.034-1.478-2.034 1.478.777-2.391-2.035-1.478H4.08z"
                  ></path>
                  <path fill="#F0F0F0" d="M7.131 12H2.583v2.086h4.548z"></path>
                  <path
                    fill="#000"
                    d="m7.992 9.607-.738-.738-2.397 2.398-2.398-2.398-.738.738 2.4 2.396-2.4 2.4.738.727 2.398-2.393 2.397 2.393.738-.728-2.4-2.4z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1600">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "sbd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1615)">
                  <path
                    fill="#496E2D"
                    d="M20.486 20.485c4.5-4.5 4.678-11.686.535-16.4L12.001 12 4.086 21.02c4.713 4.143 11.898 3.966 16.4-.535"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M3.515 3.514c4.5-4.5 11.686-4.678 16.4-.535L12 12l-9.02 7.914c-4.143-4.714-3.966-11.9.535-16.4"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M19.914 2.98 2.979 19.915a12 12 0 0 0 1.107 1.106L21.021 4.087a12 12 0 0 0-1.107-1.107"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m5.057 4.174.259.798h.838l-.678.492.259.797-.678-.492-.678.492.259-.797-.678-.492h.838zM9.338 4.174l.259.797h.838l-.678.492.259.798-.678-.493-.679.493.26-.798-.679-.492h.839zM5.056 8.348l.26.797h.838l-.678.493.258.797-.678-.493-.678.493.26-.797-.679-.493h.838zM9.338 8.348l.259.797h.838l-.678.493.259.797-.678-.493-.679.493.26-.797-.679-.493h.839zM7.197 6.262l.26.797h.837l-.678.493.26.797-.679-.493-.678.493.259-.797-.678-.493h.838z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1615">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "try":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1625)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m11.509 9.805.984 1.357 1.595-.517L13.102 12l.984 1.357-1.594-.519-.986 1.356.001-1.677L9.913 12l1.595-.518z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M8.822 15.39a3.391 3.391 0 1 1 1.613-6.374 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.613.408"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1625">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bsd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1630)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M7.306 7.825h15.949C21.559 3.255 17.16 0 12 0a11.96 11.96 0 0 0-8.485 3.515zM7.305 16.173h15.949c-1.696 4.57-6.094 7.826-11.254 7.826a11.96 11.96 0 0 1-8.485-3.515z"
                  ></path>
                  <path
                    fill="#000"
                    d="M3.514 3.514c-4.686 4.687-4.686 12.285 0 16.97L12 12z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1630">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ern":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1651)">
                  <path
                    fill="#338AF3"
                    d="M10.957 10.957s-7.435 9.53-7.442 9.528A11.96 11.96 0 0 0 12 24c6.628 0 12-5.372 12-12z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M10.957 12S3.522 3.513 3.515 3.514A11.96 11.96 0 0 1 12 0c6.628 0 12 5.372 12 12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M3.514 3.516c-4.686 4.686-4.686 12.284 0 16.97 0 .002 20.486-8.485 20.486-8.485z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M6.26 7.043a4.18 4.18 0 0 0-4.173 4.174v1.565a4.18 4.18 0 0 0 4.173 4.174 4.18 4.18 0 0 0 4.174-4.174v-1.565A4.18 4.18 0 0 0 6.26 7.043m2.61 5.74a2.61 2.61 0 0 1-1.827 2.488v-1.706l1.107-1.107-1.106-1.107v-.916H5.477V12L4.37 13.106l1.107 1.107v1.058a2.61 2.61 0 0 1-1.826-2.489v-1.565A2.61 2.61 0 0 1 6.26 8.61a2.61 2.61 0 0 1 2.61 2.608z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1651">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "hnl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1656)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 23.999a12 12 0 0 0 10.81-6.783H1.19A12 12 0 0 0 12 24M12-.001A12 12 0 0 0 1.193 6.782H22.81A12 12 0 0 0 12-.001M7.386 7.824l.388 1.196h1.257l-1.017.74.389 1.195-1.018-.74-1.017.74.389-1.196L5.74 9.02h1.257zM7.386 13.043l.388 1.195h1.257l-1.017.74.389 1.195-1.018-.74-1.017.74.389-1.196-1.017-.739h1.257zM16.615 7.824l.389 1.196h1.257l-1.017.74.388 1.195-1.017-.74-1.017.74.388-1.196-1.017-.739h1.258zM16.615 13.043l.389 1.195h1.257l-1.017.74.388 1.195-1.017-.74-1.017.74.388-1.196-1.017-.739h1.258zM12 10.433l.389 1.196h1.257l-1.017.74.388 1.195-1.017-.74-1.017.74.388-1.196-1.017-.739h1.257z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1656">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "lrd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1666)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M2.743 4.363h18.514A12 12 0 0 0 18.9 2.181H5.1c-.88.62-1.673 1.354-2.357 2.182M0 12q0 .552.05 1.092h23.9a12 12 0 0 0 0-2.182H.05Q0 11.45 0 12M1.309 17.455h21.383q.532-1.04.856-2.182H.452c.215.76.504 1.49.857 2.182M5.1 21.818h13.8c.88-.62 1.673-1.354 2.357-2.182H2.743A12 12 0 0 0 5.1 21.818M.452 8.728h23.096c-.215-.76-.503-1.49-.856-2.182H1.309a12 12 0 0 0-.857 2.182"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M5.738 2.182H18.9A11.95 11.95 0 0 0 12 0c-1.566 0-4.31.808-6.262 2.182M11.478 6.545h11.213c-.399-.78-.88-1.512-1.434-2.182h-9.779zM11.478 10.909H23.95a12 12 0 0 0-.402-2.182h-12.07zM.451 15.274h23.097a12 12 0 0 0 .402-2.182H.05c.067.749.203 1.479.401 2.182M2.743 19.637h18.514a12 12 0 0 0 1.434-2.182H1.308c.4.78.881 1.512 1.435 2.182M12 24c2.568 0 4.948-.807 6.9-2.181H5.099a11.95 11.95 0 0 0 6.9 2.182"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M.452 8.727a12 12 0 0 0-.402 2.182H12V-.001C6.507 0 1.877 3.69.452 8.728"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m7.144 3.13.777 2.392h2.514L8.401 7l.777 2.391-2.034-1.478-2.035 1.478L5.886 7 3.852 5.522h2.515z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1666">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mmk":
            return (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_0_1683)">
                  <path
                    d="M23.2534 16.1744C23.7358 14.8744 23.9998 13.4683 23.9998 12.0005C23.9998 10.5326 23.7358 9.1265 23.2534 7.82657L11.9998 6.78308L0.746208 7.82657C0.263864 9.1265 -0.000183105 10.5326 -0.000183105 12.0005C-0.000183105 13.4683 0.263864 14.8744 0.746208 16.1744L11.9998 17.2178L23.2534 16.1744Z"
                    fill="#6DA544"
                  />
                  <path
                    d="M23.2535 7.82605C21.558 3.25644 17.1595 -6.10352e-05 11.9999 -6.10352e-05C6.84034 -6.10352e-05 2.44182 3.25644 0.746307 7.82605H23.2535Z"
                    fill="#FFDA44"
                  />
                  <path
                    d="M11.9999 23.9991C17.1595 23.9991 21.558 20.7426 23.2535 16.173H0.746277C2.44179 20.7426 6.84031 23.9991 11.9999 23.9991Z"
                    fill="#D80027"
                  />
                  <path
                    d="M20.2292 10.153H13.9429L12.0003 4.17438L10.0577 10.153H3.77148L8.85719 13.8479L6.91459 19.8266L12.0003 16.1744L17.0861 19.8265L15.1435 13.8479L20.2292 10.153Z"
                    fill="#F0F0F0"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_1683">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            );

          case "sos":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1696)">
                  <path
                    fill="#338AF3"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m12 6.26 1.295 3.986h4.191l-3.39 2.464 1.295 3.985L12 14.232 8.61 16.696l1.295-3.986-3.39-2.464h4.19z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1696">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bhd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1727)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0C9.592 0 7.35.708 5.47 1.93L8.557 4l-3.861 2 3.86 2-3.86 2 3.86 2-3.86 2 3.86 2-3.86 2 3.86 2-3.086 2.069A11.94 11.94 0 0 0 12 23.999c6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1727">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "hkd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1738)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M13.24 9.078c-.274 1.134-.758.918-.996 1.907a2.609 2.609 0 0 1 1.22-5.073c-.476 1.978.02 2.151-.225 3.166M9.604 9.918c.995.61.64 1.004 1.507 1.535a2.609 2.609 0 1 1-4.448-2.727c1.734 1.064 2.052.646 2.941 1.192M9.28 13.635c.887-.757 1.152-.298 1.926-.958a2.609 2.609 0 0 1-3.968 3.387c1.547-1.32 1.248-1.752 2.042-2.429M12.715 15.092c-.446-1.078.073-1.188-.316-2.128a2.609 2.609 0 0 1 1.995 4.82c-.778-1.88-1.28-1.728-1.679-2.692M15.162 12.274c-1.163.091-1.107-.436-2.121-.357a2.609 2.609 0 0 1 5.201-.408c-2.029.16-2.04.684-3.08.765"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1738">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "lyd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1746)">
                  <path
                    fill="#000"
                    d="M1.19 6.783A11.95 11.95 0 0 0 0 12c0 1.87.428 3.64 1.19 5.218L12 18.26l10.81-1.043A11.95 11.95 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 5.739z"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M1.191 17.217a12 12 0 0 0 10.81 6.782 12 12 0 0 0 10.808-6.782z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M1.191 6.783H22.81A12 12 0 0 0 12 0 12 12 0 0 0 1.191 6.783"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m14.793 9.805.985 1.357 1.594-.518L16.386 12l.985 1.357-1.594-.52-.986 1.357v-1.677l-1.593-.519 1.594-.517z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12.107 15.39a3.391 3.391 0 1 1 1.613-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.03.408-1.613.408"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1746">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "nad":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1753)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M3.515 20.485c.503.503 1.04.952 1.603 1.348L21.833 5.118a12.1 12.1 0 0 0-2.952-2.951L2.167 18.88q.592.846 1.348 1.604"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M3.515 3.515C-.271 7.3-.998 12.986 1.333 17.502l16.17-16.169C12.985-.997 7.3-.27 3.514 3.515"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M20.486 20.485c3.785-3.786 4.512-9.472 2.182-13.988l-16.17 16.17c4.516 2.33 10.202 1.603 13.988-2.182"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m9.913 6.782-1.344.632.716 1.303-1.46-.28-.186 1.475-1.017-1.085-1.017 1.085-.185-1.475-1.46.28.716-1.303-1.344-.632 1.344-.633-.716-1.302 1.46.28.185-1.476 1.017 1.085L7.64 3.651l.185 1.475 1.46-.279L8.57 6.15z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1753">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "qar":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1759)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#751A46"
                    d="M24 12c0-6.627-5.373-12-12-12-2.347 0-4.537.675-6.387 1.84l2.63 1.117-3.547 1.508 3.548 1.507L4.696 7.48l3.548 1.508-3.548 1.507L8.244 12l-3.548 1.507 3.548 1.507-3.548 1.507 3.548 1.508-3.548 1.507 3.548 1.507-2.63 1.117A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1759">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "zar":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1762)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M3.514 20.485c-4.686-4.686-4.686-12.284 0-16.97L10.434 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M10.435 12 1.592 6.024q-.411.716-.724 1.49L5.345 12 .868 16.488q.313.772.723 1.487z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M23.899 10.435H10.434l-6.92-6.92a12 12 0 0 0-1.923 2.509L7.556 12l-5.965 5.975c.53.92 1.178 1.764 1.924 2.51l6.92-6.92h13.463a12.1 12.1 0 0 0 0-3.13"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M4.694 21.518A11.95 11.95 0 0 0 12 23.998c5.544 0 10.21-3.76 11.586-8.869H11.083z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.586 8.869C22.21 3.759 17.544-.001 12-.001 9.25 0 6.717.925 4.694 2.48l6.389 6.389z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1762">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bdt":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1783)">
                  <path
                    fill="#496E2D"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M9.391 17.217a5.217 5.217 0 1 0 0-10.434 5.217 5.217 0 0 0 0 10.434"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1783">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "clp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1786)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12 0-6.627 12 0 12 0z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M0 12C0 5.373 5.373 0 12 0v12z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m7.143 4.173.777 2.392h2.514L8.4 8.043l.777 2.391-2.034-1.478-2.034 1.478.777-2.391L3.85 6.565h2.515z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1786">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "etb":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1791)">
                  <path
                    fill="#FFDA44"
                    d="M0 12c0 1.468.264 2.874.746 4.174L12 17.217l11.253-1.043c.483-1.3.747-2.706.747-4.174 0-1.448-.257-2.836-.727-4.12L12 6.782.726 7.879A12 12 0 0 0 0 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24c5.16 0 9.558-3.256 11.253-7.826H.746C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 0C6.84 0 2.442 3.256.746 7.826h22.508C21.558 3.256 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 17.74a5.74 5.74 0 1 0 0-11.478 5.74 5.74 0 0 0 0 11.478"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m11.999 7.556 1.036 3.189h3.358l-2.718 1.97 1.044 3.199-2.72-1.98-2.717 1.976 1.04-3.194-2.715-1.971h3.356z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m16.13 12.794-3.286-1.068 2.031-2.796-.844-.613L12 11.113 9.969 8.317l-.844.613 2.03 2.796-3.286 1.068.323.992 3.286-1.067v3.455h1.044V12.72l3.286 1.067z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1791">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "huf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1799)">
                  <path
                    fill="#F0F0F0"
                    d="M.746 7.825A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 17.217l11.253-1.044c.483-1.3.747-2.706.747-4.174s-.264-2.874-.747-4.174L12 6.782z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12-.001C6.84-.001 2.442 3.256.747 7.825h22.507C21.558 3.255 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.827H.747C2.442 20.743 6.84 24 12 24"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1799">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mkd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1814)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M13.825 23.862a11.94 11.94 0 0 0 5.271-2.185L12 12zM10.175.138a11.94 11.94 0 0 0-5.271 2.185L12 12zM4.904 21.677a11.94 11.94 0 0 0 5.271 2.185L12 12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M2.323 4.902a11.94 11.94 0 0 0-2.185 5.272L12 11.999zM.138 13.825a11.94 11.94 0 0 0 2.186 5.272L12 12zM23.862 10.174a11.94 11.94 0 0 0-2.185-5.271L12 11.999z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M19.096 2.323a11.94 11.94 0 0 0-5.27-2.185L12 12zM21.677 19.097a11.94 11.94 0 0 0 2.185-5.272L12 12z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 16.174a4.174 4.174 0 1 0 0-8.347 4.174 4.174 0 0 0 0 8.347"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 15.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.26"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1814">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "krw":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1827)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M16.174 12c0 1.043-1.869 3.652-4.174 3.652S7.826 13.043 7.826 12a4.174 4.174 0 0 1 8.348 0"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M16.174 12a4.174 4.174 0 1 1-8.348 0"
                  ></path>
                  <path
                    fill="#000"
                    d="m17.534 14.583-1.107 1.106.738.738 1.106-1.107zM15.689 16.427l-1.107 1.107.738.737 1.106-1.106zM19.747 16.795 18.64 17.9l.738.738 1.107-1.106zM17.903 18.64l-1.107 1.108.738.737 1.107-1.106zM18.64 15.69l-1.106 1.106.738.738 1.107-1.107zM16.796 17.534l-1.107 1.107.738.738 1.107-1.107zM15.69 5.358l2.95 2.952.738-.738-2.95-2.952zM14.583 6.466l1.107 1.107.737-.738-1.106-1.107zM16.427 8.31l1.107 1.107.738-.738-1.107-1.107zM16.795 4.252l1.107 1.107.738-.738-1.107-1.107zM18.64 6.098l1.108 1.106.737-.737L19.38 5.36zM7.203 19.748l-2.95-2.951-.739.737 2.952 2.952zM8.31 18.64l-1.106-1.107-.738.738 1.107 1.107zM6.466 16.796l-1.107-1.107-.738.738 1.107 1.107zM9.417 17.534l-2.95-2.952-.739.738 2.952 2.951zM4.253 7.205l2.951-2.952-.738-.737-2.951 2.95zM5.359 8.31 8.31 5.358l-.738-.737-2.951 2.951zM6.466 9.417l2.952-2.951-.738-.738-2.951 2.951z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1827">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bbd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1871)">
                  <path
                    fill="#FFDA44"
                    d="M17.217 1.19A11.95 11.95 0 0 0 12 0c-1.87 0-3.64.428-5.217 1.19L5.739 12l1.043 10.81A11.95 11.95 0 0 0 12 24c1.87 0 3.64-.428 5.217-1.19L18.261 12z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M6.783 1.191A12 12 0 0 0 0 12.001a12 12 0 0 0 6.783 10.808zM17.218 1.192v21.617A12 12 0 0 0 24 12.001a12 12 0 0 0-6.782-10.81"
                  ></path>
                  <path
                    fill="#000"
                    d="m15.652 7.303.7.35zl-.7-.35c-.042.085-.956 1.945-1.105 4.785h-1.064V7.303L12 6.26l-.783 1.043v4.435h-1.064c-.149-2.84-1.063-4.7-1.105-4.785l-1.4.7c.01.02.96 1.956.96 4.868v.782h2.61v4.435h1.565v-4.435h2.608v-.782c0-1.506.26-2.747.48-3.524.238-.846.48-1.34.482-1.345z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1871">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "fkp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1885)">
                  <path
                    fill="#0052B4"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path fill="#F0F0F0" d="M11.967 12H12v-.032z"></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 6.26V0h-.002C5.37 0 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.786L8.474 6.261z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M6.07 1.565A12.06 12.06 0 0 0 1.566 6.07V12h3.13V4.695H12v-3.13z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 10.524 7.736 6.261H6.261L12 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M19.305 14.086v.522H15.13v-.522h-1.565v2.087h1.043v.522h5.217v-.522h1.044v-2.087z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M13.566 6.262V12c0 2.795 3.652 3.652 3.652 3.652S20.87 14.796 20.87 12V6.26z"
                  ></path>
                  <path
                    fill="#F3F3F3"
                    d="M17.218 10.543c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835v1.46c.913 0 .913.835 1.826.835s.913-.834 1.826-.834.913.835 1.826.835.913-.835 1.826-.835v-1.461c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835M17.218 7.618c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835V9.08c.913 0 .913.835 1.826.835s.913-.835 1.826-.835.913.835 1.826.835.913-.835 1.826-.835v-1.46c-.913 0-.913.834-1.826.834s-.913-.835-1.826-.835"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1885">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "isk":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1899)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M.413 15.13a12 12 0 0 0 4.283 6.39v-6.39zM10.956 23.954q.516.045 1.044.046c5.544 0 10.21-3.76 11.586-8.87h-12.63zM23.586 8.87C22.21 3.76 17.544 0 12 0q-.528 0-1.044.045V8.87zM4.696 2.48A12 12 0 0 0 .413 8.87h4.283z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.898 10.435H9.391V.285C8.282.532 7.231.93 6.261 1.46v8.976H.1a12 12 0 0 0 0 3.13h6.16v8.976c.97.53 2.021.928 3.13 1.174v-10.15h14.507a12.1 12.1 0 0 0 0-3.13"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1899">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ltl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1907)">
                  <path
                    fill="#6DA544"
                    d="M23.254 16.174c.482-1.3.746-2.706.746-4.173s-.264-2.874-.746-4.174L12 6.783.747 7.827A12 12 0 0 0 0 12c0 1.467.264 2.873.747 4.173L12 17.218z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M23.254 7.826C21.558 3.256 17.16 0 12 0S2.442 3.256.747 7.826z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24c5.16 0 9.558-3.256 11.254-7.825H.747C2.442 20.745 6.84 24 12 24"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1907">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "npr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1911)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M23.93 13.304 10.77.062A12 12 0 0 0 9.03.37C3.839 1.692 0 12 0 12s16.8 11.242 18.716 9.945q.576-.39 1.102-.842l-7.8-7.799z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M20.87 12 9.2.329C3.922 1.591 0 6.337 0 11.999c0 6.628 5.373 12 12 12 2.514 0 4.847-.773 6.775-2.094L8.87 11.999z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m11.413 17.718-1.466-.69.78-1.42-1.591.305-.202-1.607-1.108 1.182-1.109-1.182-.201 1.607-1.592-.304.78 1.42-1.465.689 1.466.689-.78 1.42 1.59-.305.202 1.607 1.109-1.182 1.108 1.182.202-1.607 1.591.304-.78-1.42zM10.434 6.655l-1.066-.501.568-1.033-1.158.222-.146-1.17-.806.86-.807-.86-.146 1.17-1.158-.222.568 1.033-1.066.501 2.609.522z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M10.957 6.655a3.13 3.13 0 1 1-6.261 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1911">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "pln":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1921)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1921">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ssp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1924)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M23.064 7.347C21.247 3.03 16.977-.001 12-.001a11.96 11.96 0 0 0-8.485 3.515L6.52 7.347z"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="m6.554 16.608-3.039 3.876A11.96 11.96 0 0 0 12 23.999c4.994 0 9.275-3.051 11.082-7.391z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M2.609 8.826v6.304h20.978c.269-.998.413-2.047.413-3.13 0-1.099-.148-2.163-.425-3.174z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m3.909 9.016 1.464 2.044L7.77 10.3l-1.491 2.024 1.464 2.044-2.386-.792L3.866 15.6l.016-2.515-2.386-.793 2.396-.761z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1924">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ugx":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1931)">
                  <path
                    fill="#FFDA44"
                    d="M20.943 20A11.96 11.96 0 0 0 24 12c0-3.073-1.157-5.877-3.057-8L12 3.13 3.056 4A11.95 11.95 0 0 0 0 12c0 3.074 1.156 5.877 3.056 8l8.944.87z"
                  ></path>
                  <path
                    fill="#000"
                    d="M3.057 4h17.886A11.97 11.97 0 0 0 12 0a11.97 11.97 0 0 0-8.943 4"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m0 12 12 1.044 12-1.043c0-1.403-.242-2.75-.684-4H.683A12 12 0 0 0 0 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M.683 16h22.633c.442-1.252.684-2.598.684-4H0c0 1.402.241 2.748.683 4"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M20.944 20H3.057A11.97 11.97 0 0 0 12 24a11.97 11.97 0 0 0 8.944-4"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M16.004 12a4.004 4.004 0 1 1-8.008.001 4.004 4.004 0 0 1 8.008 0"
                  ></path>
                  <path
                    fill="#000"
                    d="m13.467 12.204-1.468-.636s.344-1.14.362-1.217a.78.78 0 0 0-.209-.73l.37-.37a1.3 1.3 0 0 0-1.845 0l.368.37a.78.78 0 0 0-.195.78l-.555.555h1.01s-.418.627-.646 1.142a1.053 1.053 0 0 0 .53 1.377l.304.135.506.476v.522l-.521.522h1.043v-1.044l.476-.476h.985l.014-.03a1.044 1.044 0 0 0-.53-1.376"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1931">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "byr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1939)">
                  <path
                    fill="#FCFCFC"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M4.957 11.129 3.652 8.763l1.305-2.33 1.304 2.33zM2.348 11.129 1.043 8.763l1.305-2.33 1.304 2.33zM4.957 17.564l-1.305-2.366 1.305-2.33 1.304 2.33zM2.348 17.564l-1.305-2.366 1.305-2.33 1.304 2.33zM6.26 2.329l-.369-.66q-.995.591-1.856 1.355l.921 1.671zM4.956 19.304l-.93 1.662c.571.51 1.192.964 1.854 1.357l.38-.69z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M7.304 15.13v7.916C8.746 23.66 10.334 24 12 24c5.16 0 9.558-3.256 11.253-7.826z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M23.254 16.174c.482-1.3.746-2.706.746-4.174 0-6.627-5.373-12-12-12-1.666 0-3.254.34-4.696.954v15.22z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1939">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          case "ddk":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1962)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="m23.478 12 .42-1.565a12 12 0 0 0-.311-1.565h-12.63V.046a12 12 0 0 0-1.566.24l-2.087 1.28-1.043-.106q-.825.45-1.565 1.02v6.39H.413q-.206.764-.311 1.565L.522 12l-.42 1.565q.105.801.311 1.565h4.283v6.39q.74.57 1.565 1.02l1.565-.105 1.565 1.28q.766.169 1.565.24V15.13h12.63q.207-.765.312-1.566z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.898 10.435H9.391V.285C8.282.531 7.231.93 6.261 1.46v8.976H.1a12.1 12.1 0 0 0 0 3.13h6.16v8.976c.97.53 2.021.928 3.13 1.174v-10.15h14.507a12.1 12.1 0 0 0 0-3.13"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1962">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "inr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1966)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M12-.001A12 12 0 0 0 1.19 6.782h21.62A12 12 0 0 0 12-.001"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24a12 12 0 0 0 10.81-6.783H1.19A12 12 0 0 0 12 24"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 16.173a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 14.608a2.609 2.609 0 1 0 0-5.217 2.609 2.609 0 0 0 0 5.217"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="m12 8.78.805 1.826 1.983-.216L13.61 12l1.178 1.61-1.983-.216L12 15.219l-.804-1.825-1.983.216L10.39 12l-1.178-1.61 1.983.216z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1966">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "luc":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1973)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0C6.84 0 2.442 3.256.747 7.826h22.507C21.558 3.256 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 24c5.16 0 9.558-3.256 11.254-7.825H.747C2.442 20.745 6.84 24 12 24"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1973">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "uah":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_1990)">
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_1990">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "fjd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2009)">
                  <path
                    fill="#338AF3"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 5.74v4.048L7.824 5.74zM6.26 12.002h3.526L6.26 7.306l-.521 3.652z"
                  ></path>
                  <path fill="#F0F0F0" d="M11.967 12H12v-.032z"></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 6.262V0h-.002C5.37 0 0 5.374 0 12h6.26V8.475l3.526 3.526h2.182l.032-.032V9.787L8.474 6.262z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M6.07 1.566a12.06 12.06 0 0 0-4.505 4.506V12h3.13V4.696H12v-3.13z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 10.525 7.736 6.262H6.261L12 12z"
                  ></path>
                  <path
                    fill="#F3F3F3"
                    d="M13.566 7.827v4.174c0 2.796 3.652 3.652 3.652 3.652s3.652-.856 3.652-3.652V7.827l-3.652-1.043z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M20.87 7.826V6.261h-7.304v1.565h3.13v3.13h-3.13V12h3.13v3.492c.315.112.522.16.522.16s.206-.048.521-.16V12h3.13v-1.043h-3.13v-3.13z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2009">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "idr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2023)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2023">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mop":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2026)">
                  <path
                    fill="#496E2D"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M14.087 11.5c-.295 0-.574.059-.834.152.142-.317.238-.67.238-1.046C13.49 9.116 12 7.997 12 7.997s-1.49 1.118-1.49 2.609c0 .377.095.73.237 1.047a2.5 2.5 0 0 0-.834-.153c-1.49 0-2.609 1.49-2.609 1.49s1.118 1.492 2.609 1.492c.874 0 1.62-.513 2.087-.937.468.424 1.213.937 2.087.937 1.49 0 2.609-1.491 2.609-1.491s-1.119-1.49-2.61-1.49"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 4.695.309.947h.996l-.806.586.308.948L12 6.59l-.806.586.307-.948-.806-.586h.997zM8.211 6.352l.593.533.69-.399-.324.729.592.533-.793-.083-.324.728-.166-.78-.792-.083.69-.399zM5.438 9.126l.78.166.398-.69.083.792.78.166-.728.324.083.793-.533-.592-.729.324.399-.69zM15.79 6.352l-.593.533-.69-.399.324.729-.592.533.792-.083.325.728.166-.78.792-.083-.69-.399zM18.563 9.126l-.78.166-.398-.69-.084.792-.78.166.73.324-.084.793.533-.592.728.324-.398-.69z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 18.655a5.2 5.2 0 0 0 3.15-1.06H8.85a5.2 5.2 0 0 0 3.15 1.06M7.217 15.524q.251.57.622 1.06h8.322c.246-.326.456-.68.622-1.06z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2026">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "nzd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2038)">
                  <path
                    fill="#0052B4"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M11.968 12h.033v-.032zM12 6.26V0h-.002C5.372.001 0 5.373 0 12h6.261V8.475L9.787 12h2.181l.032-.032V9.787L8.475 6.26z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M6.071 1.565a12.06 12.06 0 0 0-4.506 4.506V12h3.13V4.696H12V1.564z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 10.525 7.737 6.26H6.261l5.74 5.74zM20.781 8.905l.26.797h.837l-.678.492.26.798-.679-.493-.678.493.259-.798-.678-.492h.838zM17.785 14.644l.389 1.195h1.257l-1.018.74.39 1.195-1.018-.739-1.017.739.388-1.196-1.017-.739h1.257zM17.899 5.252l.323.996h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048zM15.015 8.87l.389 1.196h1.257l-1.017.739.388 1.196-1.017-.74-1.017.74.389-1.196-1.018-.74h1.258z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2038">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "rou":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2051)">
                  <path
                    fill="#FFDA44"
                    d="M16.174.745A12 12 0 0 0 12 0c-1.468 0-2.874.264-4.174.746L6.783 12l1.043 11.254c1.3.482 2.706.746 4.174.746s2.874-.264 4.174-.746l1.044-11.254z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 12C24 6.84 20.743 2.44 16.174.746v22.507C20.744 21.558 24 17.16 24 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M0 12c0 5.16 3.257 9.558 7.826 11.253V.746C3.256 2.441 0 6.84 0 11.999"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2051">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ron":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2055)">
                  <path fill="#FF9811" d="M0 2.086v19.826V2.086"></path>
                  <path
                    fill="#FFDA44"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M9.391 2.086H5.236q-.276.189-.54.393l-1.044 9.52 1.043 9.52q.265.204.541.393h4.155z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M0 12a11.98 11.98 0 0 0 4.696 9.521V2.48A11.98 11.98 0 0 0 0 12"
                  ></path>
                  <path fill="#FFDA44" d="M19.304 7.315v.3l.012.003z"></path>
                  <path
                    fill="#A2001D"
                    d="M23.044 15.13h-2.261l-.957 1.043v2.087H17.74v-1.043h1.044V15.13h-4.696v1.304h-1.043v-2.486a1.56 1.56 0 0 1-.522-1.166V5.999c0-.864.7-1.565 1.565-1.565v9.652h2.087l.716-.597a2.5 2.5 0 0 1-.194-.968v-1.565H15.13v-3.13h3.13c0-.522.784-1.044.784-1.044s.782.522.782 1.043v3.131c.58.007 1.503-.008 2.5 0-.263-.458-.413-1-.413-1.565 0-.921.398-1.749 1.03-2.322a12.05 12.05 0 0 0-4.18-4.983h-7.807v19.826h7.808a12.03 12.03 0 0 0 4.692-6.332z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2055">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          // double check aed
          case "aed":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2062)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="m6.783 16.173 1.043 7.08c1.3.482 2.706.746 4.174.746 5.16 0 9.558-3.256 11.253-7.826z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M6.783 7.827 7.826.747C9.126.264 10.532 0 12 0c5.16 0 9.558 3.257 11.253 7.827z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M0 12c0 5.16 3.257 9.558 7.826 11.254V.746C3.256 2.442 0 6.84 0 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2062">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bzd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2067)">
                  <path
                    fill="#0052B4"
                    d="M24 12c0-4.118-2.076-7.752-5.237-9.913L12 1.565l-6.764.522A11.99 11.99 0 0 0 0 12c0 4.119 2.075 7.752 5.236 9.913l6.764.522 6.763-.522A11.99 11.99 0 0 0 24 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M18.764 2.087A11.94 11.94 0 0 0 12.001 0C9.49 0 7.163.77 5.237 2.087zM5.236 21.913A11.94 11.94 0 0 0 12 24c2.509 0 4.837-.77 6.763-2.087z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 17.738A5.74 5.74 0 1 0 12 6.26a5.74 5.74 0 0 0 0 11.478"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 16.696a4.696 4.696 0 1 0 0-9.392 4.696 4.696 0 0 0 0 9.391"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M12 15.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.26"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 11.217 10.304 12v1.304l1.695 1.044 1.696-1.044V12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M13.695 10.436h-3.391V12h3.391z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2067">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "cop":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2077)">
                  <path
                    fill="#FFDA44"
                    d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12l-12 1.043z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M1.606 18C3.68 21.588 7.558 24 12 24s8.32-2.413 10.394-6L12 17.219z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M22.394 18A11.95 11.95 0 0 0 24 12H0c0 2.186.584 4.235 1.605 6z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2077">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "irr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2084)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M15.898 8.87h-1.57q.02.258.02.521c0 1.161-.29 2.286-.796 3.087-.156.247-.418.596-.77.831V8.87h-1.564v4.44c-.351-.235-.614-.584-.77-.83-.506-.802-.796-1.927-.796-3.088q.001-.263.02-.521h-1.57q-.015.257-.015.521c0 3.219 1.719 5.74 3.913 5.74s3.913-2.521 3.913-5.74q0-.264-.015-.521"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M4.957 5.738h1.565v1.044h1.565V5.738h1.565v1.044h1.566V5.738h1.565v1.044h1.565V5.738h1.565v1.044h1.566V5.738h1.565v1.044h3.765A12 12 0 0 0 12-.001 12 12 0 0 0 1.191 6.782h3.766z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M19.044 17.217v1.044h-1.565v-1.044h-1.566v1.044h-1.565v-1.044h-1.565v1.044h-1.565v-1.044H9.653v1.044H8.087v-1.044H6.522v1.044H4.957v-1.044H1.19A12 12 0 0 0 12.001 24a12 12 0 0 0 10.809-6.783z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2084">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mga":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2089)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M7.826 12v11.253c1.3.482 2.706.747 4.174.747 6.628 0 12-5.373 12-12 0-6.628-16.174 0-16.174 0"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0c-1.468 0-2.874.264-4.174.747V12H24c0-6.627-5.372-12-12-12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2089">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "nio":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2093)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 0A12 12 0 0 0 1.191 6.782H22.81A12 12 0 0 0 12 0M12 24.001a12 12 0 0 0 10.81-6.783H1.19a12 12 0 0 0 10.81 6.783"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M12 8.348a3.652 3.652 0 1 0 0 7.304 3.652 3.652 0 0 0 0-7.304m0 5.739a2.087 2.087 0 1 1 0-4.174 2.087 2.087 0 0 1 0 4.174"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="m13.807 12.522-1.808-.521-1.807.521-.602 1.044h4.82z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="m12 9.391-1.205 2.087L12 12l1.205-.522z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M10.192 12.521h3.615l-.602-1.043h-2.41z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2093">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "rub":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2102)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M23.254 16.173c.482-1.3.746-2.706.746-4.173s-.264-2.874-.746-4.174H.747A12 12 0 0 0 0 12c0 1.467.264 2.873.747 4.173L12 17.217z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.827H.747C2.442 20.743 6.84 24 12 24"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2102">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          // double check gbp
          case "gbp":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2115)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M2.48 4.693A12 12 0 0 0 .414 8.868h6.243zM23.587 8.869a12 12 0 0 0-2.067-4.176L17.344 8.87zM.413 15.13a12 12 0 0 0 2.068 4.176l4.175-4.176zM19.306 2.48A12 12 0 0 0 15.13.412v6.243zM4.694 21.518a12 12 0 0 0 4.175 2.067v-6.243zM8.87.412A12 12 0 0 0 4.693 2.48l4.175 4.175zM15.13 23.585a12 12 0 0 0 4.175-2.067l-4.175-4.176zM17.344 15.13l4.176 4.176a12 12 0 0 0 2.067-4.176z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m15.13 15.131 5.355 5.355q.37-.37.706-.77l-4.585-4.585zM8.87 15.131l-5.355 5.355q.37.369.77.705l4.585-4.584zM8.87 8.87 3.514 3.514q-.37.37-.706.77L7.394 8.87zM15.13 8.87l5.355-5.355a12 12 0 0 0-.77-.705L15.13 7.394z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2115">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          // double check xof
          case "xof":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2132)">
                  <path
                    fill="#D80027"
                    d="m7.826 10.957 1.044 12.63c.998.269 2.047.413 3.13.413 6.628 0 12-5.372 12-12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M7.826 12 8.87.414A12 12 0 0 1 12 0c6.628 0 12 5.373 12 12z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M0 12c0 5.544 3.76 10.21 8.87 11.586V.413C3.76 1.79 0 6.455 0 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2132">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "kmf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2136)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M24 11.965H10.99c-2.583 2.583-4.144 4.577-5.739 6.172l6.783.61 10.525-1.043A11.95 11.95 0 0 0 24 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M5.253 6.226h17.269A12 12 0 0 0 12-.001a11.96 11.96 0 0 0-8.467 3.498z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M5.773 17.704c-1.078 1.079-1.495 1.983-2.276 2.763A11.96 11.96 0 0 0 12 24c4.562 0 8.53-2.547 10.56-6.296z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M3.514 3.48c-4.686 4.687-4.686 12.285 0 16.971L12 11.966z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M3.165 11.965a3.65 3.65 0 0 1 2.87-3.568 3.652 3.652 0 1 0 0 7.134 3.65 3.65 0 0 1-2.87-3.566"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m5.995 8.835.194.597h.629l-.509.37.194.598-.508-.37-.509.37.194-.598-.508-.37H5.8zM5.995 10.4l.194.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.598-.508-.37H5.8zM5.995 11.965l.194.598h.629l-.509.369.194.598-.508-.37-.509.37.194-.598-.508-.37H5.8z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m5.995 13.53.194.598h.629l-.509.37.194.597-.508-.37-.509.37.194-.598-.508-.37H5.8z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2136">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "iqd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2152)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="M12 0C6.84 0 2.442 3.255.746 7.824h22.507C21.558 3.255 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 24c5.16 0 9.558-3.256 11.254-7.826H.746C2.442 20.745 6.84 24.002 12 24.002"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M9.13 11.219H6.817c.116-.45.524-.783 1.01-.783V8.87a2.61 2.61 0 0 0-2.61 2.608v1.305h3.914c.143 0 .26.117.26.26v.522H4.174v1.566h6.783v-2.087c0-1.007-.82-1.826-1.827-1.826M13.044 13.566V8.87h-1.565v6.26h2.608v-1.564zM18.26 13.566V8.87h-1.565v4.696h-.521V12h-1.565v3.13h4.695v-1.565z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2152">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mwk":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2160)">
                  <path
                    fill="#D80027"
                    d="M0 12c0 1.468.264 2.874.746 4.174L12 16.695l11.253-.521c.483-1.3.747-2.706.747-4.174s-.264-2.874-.747-4.174L12 7.304.746 7.826A12 12 0 0 0 0 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 0C6.84 0 2.442 3.256.746 7.826h22.508C21.557 3.256 17.16 0 12 0"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M23.253 16.175H.746C2.442 20.745 6.84 24 12 24s9.558-3.257 11.253-7.826"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m15.586 5.74-1.465-.69.78-1.419-1.591.305-.202-1.608L12 3.51 10.89 2.328l-.201 1.608-1.592-.305.78 1.42-1.465.689z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2160">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "rwf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2171)">
                  <path
                    fill="#FFDA44"
                    d="M0 12c0 2.078.53 4.033 1.46 5.738L12 18.782l10.541-1.044c.93-1.705 1.46-3.66 1.46-5.739l-12-1.043z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M22.54 6.26A12 12 0 0 0 12 0 11.997 11.997 0 0 0 0 12h24c0-2.079-.529-4.034-1.46-5.74"
                  ></path>
                  <path
                    fill="#496E2D"
                    d="M12 24c4.549 0 8.506-2.532 10.541-6.262H1.46A12 12 0 0 0 12 24"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m13.565 7.022 1.466.69-.78 1.42 1.59-.305.202 1.607 1.109-1.182 1.108 1.182.202-1.607 1.591.304-.78-1.42 1.465-.689-1.465-.689.78-1.42-1.591.305-.202-1.607-1.108 1.182-1.109-1.182-.201 1.607-1.592-.304.78 1.42z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2171">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "xcd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2176)">
                  <path
                    fill="#338AF3"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path fill="#F3F3F3" d="M7.565 16.174h8.87L12 5.739z"></path>
                  <path
                    fill="#333"
                    d="M9.107 15.13 12 8.55l2.894 6.581z"
                  ></path>
                  <path fill="#FFDA44" d="M7.565 16.174h8.87L12 12.001z"></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2176">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "usd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2181)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M11.478 12H24c0-1.083-.145-2.132-.414-3.13H11.478zM11.478 5.739h10.76a12 12 0 0 0-2.769-3.13h-7.991zM12 24c2.824 0 5.42-.976 7.47-2.609H4.53A11.95 11.95 0 0 0 12 24M1.761 18.26h20.477a12 12 0 0 0 1.348-3.13H.413a12 12 0 0 0 1.348 3.13"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M5.559 1.874h1.093l-1.017.739.389 1.196-1.018-.74-1.017.74.336-1.033c-.896.746-1.68 1.62-2.328 2.594h.35l-.647.47q-.15.253-.29.513l.31.951-.578-.419q-.215.456-.392.932l.34 1.048h1.258l-1.017.74.388 1.195-1.017-.739-.61.443Q.002 11.24 0 12h12V0C9.63 0 7.42.688 5.559 1.874m.465 8.926-1.018-.739-1.017.739.389-1.196-1.017-.739h1.257l.388-1.195.389 1.195h1.257l-1.017.74zm-.389-4.691.389 1.195-1.018-.739-1.017.74.389-1.196-1.017-.74h1.257l.388-1.195.389 1.196h1.257zm4.693 4.691-1.017-.739-1.017.739.388-1.196-1.017-.739h1.257l.389-1.195.388 1.195h1.258l-1.018.74zm-.389-4.691.389 1.195-1.017-.739-1.017.74.388-1.196-1.017-.74h1.257l.389-1.195.388 1.196h1.258zm0-3.496.389 1.196-1.017-.74-1.017.74.388-1.196-1.017-.739h1.257L9.311.678l.388 1.196h1.258z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2181">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "bmd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2189)">
                  <path
                    fill="#D80027"
                    d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 5.739v4.047L7.826 5.74zM6.26 12h3.526L6.261 7.304l-.522 3.652z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M11.968 12.001H12v-.032zM11.999 6.261V.001h-.002C5.37 0-.001 5.374-.001 12h6.26V8.475l3.526 3.526h2.182l.032-.033V9.787L8.473 6.261z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M6.07 1.565a12.06 12.06 0 0 0-4.505 4.506v6.45h3.13V4.697h7.826v-3.13z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m12.476 11-4.74-4.74H6.26l6.216 6.216z"
                  ></path>
                  <path
                    fill="#F3F3F3"
                    d="M13.565 6.26v5.739c0 2.796 7.304 2.796 7.304 0v-5.74z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M13.565 12c0 2.796 3.652 3.653 3.652 3.653S20.87 14.796 20.87 12z"
                  ></path>
                  <path
                    fill="#A2001D"
                    d="m17.218 9.704-1.696.73V12l1.696 1.044L18.913 12v-1.565z"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M18.913 8.869h-3.391v1.565h3.391z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2189">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "xpf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2223)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M1.46 6.262h21.08A12 12 0 0 0 12 0C7.452 0 3.494 2.53 1.46 6.26M12 24c4.548 0 8.505-2.53 10.54-6.261H1.46a12 12 0 0 0 10.54 6.26"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M16.174 12c0 2.305-1.869 3.652-4.174 3.652S7.826 14.305 7.826 12a4.174 4.174 0 0 1 8.348 0"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M16.174 12a4.174 4.174 0 1 1-8.348 0"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M10.435 10.956H9.392v2.087h1.043zM14.609 10.956h-1.044v2.087h1.044zM12.522 9.39h-1.043v3.653h1.043z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2223">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "myr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2238)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M11.478 12H24c0-1.083-.144-2.132-.413-3.13H11.478zM11.478 5.739h10.76a12 12 0 0 0-2.768-3.13h-7.992zM12 24c2.824 0 5.42-.976 7.47-2.608H4.53A11.95 11.95 0 0 0 12 24M1.761 18.26H22.24a12 12 0 0 0 1.348-3.13H.414c.3 1.116.758 2.168 1.347 3.13"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 12V0C5.373 0 0 5.373 0 12z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M7.98 10.27a2.967 2.967 0 1 1 1.412-5.577 3.652 3.652 0 1 0 0 5.222c-.42.227-.9.356-1.412.356"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m8.817 5.217.526 1.102 1.19-.275L10 7.143l.957.759-1.191.268.003 1.221-.952-.764-.953.764.003-1.22-1.191-.27.957-.758L7.1 6.044l1.19.275z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2238">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ngn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2249)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M0 12c0 5.16 3.256 9.558 7.826 11.254V.747C3.256 2.442 0 6.84 0 12M24 12c0-5.16-3.257-9.558-7.826-11.253v22.507C20.744 21.558 24 17.16 24 12"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2249">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ury":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2271)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 8.869h11.586a12 12 0 0 0-1.348-3.13H12zM4.53 21.39h14.94a12 12 0 0 0 2.769-3.13H1.76a12 12 0 0 0 2.77 3.13M12 0v2.608h7.47A11.95 11.95 0 0 0 12-.001"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 8.869h11.586a12 12 0 0 0-1.348-3.13H12zM0 12c0 1.083.144 2.132.414 3.13h23.173c.269-.998.413-2.047.413-3.13z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m10.435 7.023-1.465.69.78 1.419-1.591-.304-.202 1.607-1.108-1.182-1.109 1.182-.202-1.607-1.59.304.78-1.42-1.466-.689 1.465-.69-.78-1.418 1.591.304.202-1.608L6.85 4.794 7.957 3.61l.202 1.608 1.591-.304-.78 1.419z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2271">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "btn":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2281)">
                  <path
                    fill="#FFDA44"
                    d="M3.514 20.485c-4.686-4.686-4.686-12.284 0-16.97 4.687-4.686 12.285-4.686 16.97 0 0 .001 3.187 10.784-1.5 15.47-4.686 4.687-15.467 1.504-15.47 1.5"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M3.515 20.485c4.686 4.686 12.284 4.686 16.97 0 4.687-4.687 4.687-12.285 0-16.971z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M18.789 6.782V4.695h-4l-.306.306c-1.087 1.087-.904 2.355-.77 3.28.123.86.138 1.188-.182 1.508-.319.32-.648.304-1.507.18-.926-.133-2.194-.316-3.28.771-1.088 1.087-.905 2.355-.771 3.28.124.86.139 1.189-.18 1.508-.32.32-.65.304-1.508.18a8 8 0 0 0-1.05-.102l-.023 2.087c.231.003.495.04.775.081.332.048.707.102 1.102.102.409 0 .84-.058 1.265-.242v1.67h3.13v-1.565H9.92v-1.044h1.043V15.13h-.834c.04-.506-.03-.991-.09-1.407-.123-.859-.138-1.188.18-1.507.32-.32.65-.305 1.508-.18.675.097 1.531.22 2.367-.141v1.67h3.13v-1.566h-1.565v-1.043h1.044V9.391h-.834c.04-.507-.03-.991-.09-1.407-.087-.6-.12-.942-.023-1.202z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2281">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "crc":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2285)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.254 7.826H.746A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174h22.508c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12.001 0a11.97 11.97 0 0 0-9.097 4.173h18.194A11.97 11.97 0 0 0 12 0M21.096 19.826H2.903A11.97 11.97 0 0 0 12 24c3.637 0 6.896-1.618 9.096-4.174"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2285">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          // check xaf
          case "xaf":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2291)">
                  <path
                    fill="#FFDA44"
                    d="M23.253 16.175c.483-1.3.747-2.706.747-4.174s-.264-2.874-.747-4.174L12 6.784.746 7.827A12 12 0 0 0 0 12.001c0 1.468.264 2.874.746 4.174L12 17.218z"
                  ></path>
                  <path
                    fill="#0052B4"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.826H.747C2.442 20.744 6.84 24 12 24"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 0C6.84 0 2.442 3.258.747 7.828h22.507C21.558 3.257 17.16 0 12 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2291">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "mvr":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2298)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M19.826 6.261H4.174v11.478h15.652z"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M13.932 15.391a3.391 3.391 0 1 1 1.613-6.375 4.174 4.174 0 1 0 0 5.967c-.48.26-1.029.408-1.613.408"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2298">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
          // check nzd

          case "uzs":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2332)">
                  <path
                    fill="#F0F0F0"
                    d="M.567 8.348A12 12 0 0 0 0 12c0 1.274.2 2.5.567 3.652L12 16.174l11.434-.522C23.8 14.501 24 13.274 24 12s-.199-2.5-.566-3.652L12 7.826z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M23.433 8.348 12 7.826.567 8.348Q.402 8.86.284 9.39h23.43a12 12 0 0 0-.282-1.043M.285 14.609q.118.531.281 1.043h.001L12 16.174l11.433-.521q.164-.513.281-1.044z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24c5.354 0 9.889-3.506 11.434-8.347H.567C2.112 20.494 6.647 24 12 24"
                  ></path>
                  <path
                    fill="#338AF3"
                    d="M12 0C6.646 0 2.112 3.505.567 8.346h22.866C21.888 3.506 17.354 0 12 0"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="M5.483 4.956c0-1.124.79-2.063 1.845-2.293a2.348 2.348 0 1 0 0 4.586 2.35 2.35 0 0 1-1.845-2.293M8.715 6.022l.16.49h.514l-.416.302.158.49L8.715 7l-.416.302.16-.489-.417-.302h.514zM10.358 6.022l.159.49h.514l-.416.302.159.49L10.358 7l-.417.302.16-.489-.417-.302h.515zM11.999 6.022l.159.49h.514l-.416.302.159.49L11.999 7l-.416.302.159-.489-.417-.302h.515zM13.64 6.022l.16.49h.514l-.416.302.159.49L13.64 7l-.416.302.159-.489-.417-.302h.515zM15.282 6.022l.16.49h.514l-.417.302.16.49L15.281 7l-.416.302.16-.489-.417-.302h.514zM10.358 4.315l.159.49h.514l-.416.302.159.489-.416-.303-.417.303.16-.49-.417-.302h.515zM11.999 4.315l.159.49h.514l-.416.302.159.489-.416-.303-.416.303.159-.49-.417-.302h.515zM13.64 4.315l.16.49h.514l-.416.302.159.489-.416-.303-.416.303.159-.49-.417-.302h.515zM15.282 4.315l.16.49h.514l-.417.302.16.489-.417-.303-.416.303.16-.49-.417-.302h.514zM11.999 2.608l.159.49h.514l-.416.302.159.489-.416-.303-.416.303.159-.49-.417-.302h.515zM13.64 2.608l.16.49h.514l-.416.302.159.489-.416-.303-.416.303.159-.49-.417-.302h.515zM15.282 2.608l.16.49h.514l-.417.302.16.489-.417-.303-.416.303.16-.49-.417-.302h.514z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2332">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "vuv":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2353)">
                  <path
                    fill="#000"
                    d="M24 12q-.001-.796-.101-1.565H10.435l-6.92-6.92c-4.686 4.686-4.686 12.284 0 16.97l6.92-6.92H23.9A12 12 0 0 0 24 12"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m23.997 12.273-.002.07zM23.985 12.6l-.004.069zM23.968 12.863l-.007.101zM23.929 10.692l.012.12zM23.98 11.33l.004.069q0-.034-.004-.07M23.995 11.657l.001.07q0-.036-.002-.07M23.96 11.036q.006.05.008.1z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m23.899 10.434.015.124C23.202 4.61 18.14 0 12 0a11.96 11.96 0 0 0-8.485 3.515l6.92 6.92z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M23.899 13.565H10.435l-6.92 6.92A11.96 11.96 0 0 0 12 24c6.14 0 11.202-4.61 11.914-10.558z"
                  ></path>
                  <path fill="#F0F0F0" d="m23.941 13.188-.012.12z"></path>
                  <path fill="#000" d="M23.995 12.342"></path>
                  <path
                    fill="#FFDA44"
                    d="M23.989 11.473H9.994L2.806 4.286a6 6 0 0 0-.64.83l6.874 6.879-6.88 6.88c.136.243.433.602.641.835l7.193-7.193h13.997a12 12 0 0 0-.002-1.044"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M2.915 14.557v-1.005a1.82 1.82 0 0 0 1.82-1.819c0-.71-.578-1.287-1.288-1.287a.88.88 0 0 0-.876.877c0 .31.251.56.56.56a.317.317 0 0 0 .317-.316h1.005c0 .729-.593 1.322-1.322 1.322a1.57 1.57 0 0 1-1.565-1.566c0-1.037.844-1.882 1.881-1.882a2.295 2.295 0 0 1 2.292 2.292 2.827 2.827 0 0 1-2.824 2.824"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2353">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "ves":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2379)">
                  <path
                    fill="#0052B4"
                    d="M22.809 17.217a11.95 11.95 0 0 0 1.19-5.218c0-1.87-.427-3.64-1.19-5.217l-10.81-1.044L1.19 6.782A11.95 11.95 0 0 0 0 11.999c0 1.87.427 3.64 1.19 5.218L12 18.26z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 24a12 12 0 0 0 10.809-6.782H1.19A12 12 0 0 0 12 24"
                  ></path>
                  <path
                    fill="#F0F0F0"
                    d="m20.782 14.356-.634.495.275.756-.667-.45-.634.495.222-.773-.667-.45.804-.027.222-.774.275.756zM19.159 11.544l-.426.683.517.616-.78-.195-.427.682-.056-.802-.78-.195.745-.301-.056-.803.517.617zM16.673 9.458l-.168.787.697.402-.8.085-.167.786-.327-.735-.8.085.597-.539-.327-.734.697.402zM13.622 8.348l.112.797.792.14-.723.352.112.796-.558-.578-.723.352.377-.71-.558-.578.792.14zM10.377 8.348l.377.71.792-.14-.558.58.377.71-.723-.353-.559.578.112-.796-.722-.353.792-.14zM7.326 9.458l.598.539.697-.402-.328.734.598.539-.8-.085-.327.735-.167-.787-.8-.083.697-.403zM4.84 11.545l.746.3.516-.615-.055.802.745.302-.78.194-.056.802-.426-.682-.781.195.517-.616zM3.217 14.356l.804.028.275-.755.222.773.803.028-.666.45.221.773-.633-.495-.667.45.275-.757z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M22.809 6.782A12 12 0 0 0 11.999 0 12 12 0 0 0 1.19 6.782z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2379">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "vnd":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2392)">
                  <path
                    fill="#D80027"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m12 6.261 1.295 3.986h4.191l-3.39 2.463 1.295 3.986L12 14.233 8.61 16.696l1.295-3.986-3.39-2.463h4.19z"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2392">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "yer":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2416)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#000"
                    d="M12 24c5.16 0 9.558-3.257 11.254-7.827H.746C2.442 20.743 6.84 23.999 12 23.999"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M12 0C6.84 0 2.442 3.258.746 7.828h22.508C21.558 3.257 17.16 0 12 0"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2416">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "zmw":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2420)">
                  <path
                    fill="#496E2D"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M16.695 12H12v12a12 12 0 0 0 4-.684z"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M20 20.943c2.455-2.198 4-5.39 4-8.944h-4.695z"
                  ></path>
                  <path
                    fill="#000"
                    d="M16 12v11.316a12 12 0 0 0 4-2.373v-8.944z"
                  ></path>
                  <path
                    fill="#FF9811"
                    d="M22.174 7.827h-3.13a1.044 1.044 0 0 0-2.088 0h-3.13c0 .576.502 1.043 1.078 1.043h-.035c0 .577.468 1.044 1.044 1.044 0 .576.467 1.043 1.043 1.043h2.087c.577 0 1.044-.467 1.044-1.043.576 0 1.043-.467 1.043-1.044h-.034c.576 0 1.078-.467 1.078-1.043"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2420">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );

          case "zwl":
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g clipPath="url(#clip0_0_2426)">
                  <path
                    fill="#F0F0F0"
                    d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="M22.852 6.873a12 12 0 0 0-2.447-3.437l-8.404-.827-8.405.828-.08.08 3.357 3.356L12 7.029zM3.516 20.485q.066.067.133.132l8.351.775 8.352-.775a12 12 0 0 0 2.475-3.436l-15.522-.484z"
                  ></path>
                  <path
                    fill="#000"
                    d="M23.88 10.308 9.914 9.913 12 12l-2.087 2.087 13.96-.343a12 12 0 0 0 .008-3.436"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 0a11.96 11.96 0 0 0-8.405 3.437h16.81A11.96 11.96 0 0 0 12 0"
                  ></path>
                  <path
                    fill="#D80027"
                    d="M10.308 10.309H23.88a12 12 0 0 0-1.029-3.436H6.871zM6.82 17.182h16.007c.511-1.068.87-2.223 1.046-3.436H10.255z"
                  ></path>
                  <path
                    fill="#6DA544"
                    d="M12 24a11.96 11.96 0 0 0 8.351-3.383H3.65A11.96 11.96 0 0 0 12 24"
                  ></path>
                  <path
                    fill="#000"
                    d="M4.285 2.81q-.4.337-.77.705L12 12.001l-8.485 8.485q.37.369.77.705l9.19-9.19z"
                  ></path>
                  <path
                    fill="#D80027"
                    d="m4.825 8.87.777 2.39h2.514L6.082 12.74l.777 2.391-2.034-1.478L2.79 15.13l.777-2.392-2.034-1.477h2.515z"
                  ></path>
                  <path
                    fill="#FFDA44"
                    d="m6.962 12.195-2.025-.718s-.15-1.403-.158-1.45a.783.783 0 1 0-1.524.353l-.567.571h1.01c0 1.048-.783 1.048-.783 2.092l.434 1.043h2.609l.435-1.043q.065-.151.08-.307c.375-.152.49-.541.49-.541"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_2426">
                    <path fill="#fff" d="M0 0h24v24H0z"></path>
                  </clipPath>
                </defs>
              </svg>
            );
        }
      })()}
    </div>
  );
};

export default IcCurrency;

export function ExtractPairs(symbol: string) {
  const _exceptions = [
    "US30", // Dow Jones Industrial Average
    "US500", // S&P 500
    "USTEC", // NASDAQ 100
    "DE30", // DAX (Germany 30)
    "UK100", // FTSE 100 (UK)
    "FR40", // CAC 40 (France)
    "JP225", // Nikkei 225 (Japan)
    "AU200", // ASX 200 (Australia)
    "HK50", // Hang Seng Index (Hong Kong)
    "ES35", // IBEX 35 (Spain)
    "IT40", // FTSE MIB (Italy)
    "CH20", // Swiss Market Index (SMI)
    "EU50", // Euro Stoxx 50
    "CN50", // FTSE China A50
    "IND50", // NIFTY 50 (India)
    "ZA40", // South Africa 40
    "BRASP", // Bovespa (Brazil)
    "RUS50", // MOEX Russia Index
    "KR200", // KOSPI 200 (South Korea)
    "TW50", // Taiwan 50
  ];
  if (_exceptions.includes(symbol)) {
    return [symbol];
  }
  return [symbol.slice(0, 3), symbol.slice(3)];
}
